<template>
  <div id="pano">
    <transition name="fade">
      <div v-if="panoLoading" class="pano-loading-progress">
        <img src="/static/icons/loading2.svg" />
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showSplashPopup && !forbiddenProject" id="splashPopupWrap">
        <div class="background"></div>
        <div
          class="splash-popup"
          :style="{
            width: `${splashInfo.screen_width}%`,
            border: `${splashInfo.border_size}px solid ${splashInfo.border_color}`,
            backgroundColor: splashInfo.background_color
          }"
        >
          <div class="splash-popup__content" v-html="this.splashInfo.content"></div>
          <div v-if="this.splashInfo.show_continue_button">
            <el-button
              type="primary"
              :style="{
                backgroundColor: splashInfo.continue_btn_bg_color,
                borderColor: splashInfo.continue_btn_border_color,
                color: splashInfo.continue_btn_color
              }"
              @click="continueFollowSplash()"
            >{{ splashInfo.continue_btn_text || $t('Continue') }}</el-button>
          </div>
        </div>
      </div>
    </transition>
    <!-- Wine theme -->
    <template v-if="project.theme && project.theme && project.attribute_data && project.theme.slug === 'wipo'">
      <Wine
        :theme-config="project.attribute_data"
        :scenes="scenes"
        :scene="scene"
        :thumbnail-info="thumbnailEnable ? thumbnailInfo : null"
        :visitor="visitor"
        @clickThumbnail="handleClickThumbnail"
        @clickMenu="handleClickMenuFromTheme"
      />
    </template>
    <template v-else-if="project.theme && project.theme && project.attribute_data && project.theme.slug === 'wipo-main'">
      <WineMain
        :theme-config="project.attribute_data"
        :pano-index="scenes.findIndex((item) => item.id === scene.id)"
        :visitor="visitor"
        @clickMenu="handleClickMenuFromTheme"
      />
    </template>
    <!-- Default theme -->
    <template v-else>
      <div v-if="project.name" class="project-title">
        <el-row class="mr-0 ml-0" :gutter="20">
          <el-col :xs="12" :md="6">
            <a
              v-if="!thumbnailEnable || (thumbnailInfo.show_logo !== false)"
              :href="thumbnailInfo.show_logo_company ? '#' : homepage"
              class="logo logo_branch"
            >
              <img
                v-if="thumbnailInfo.show_logo_company && thumbnailInfo.logo_company"
                :src="encodeUrl(imageUrl + thumbnailInfo.logo_company)"
                :style="{
                  width: `${thumbnailInfo.logo_horizontal_size }vw`,
                  height: `${thumbnailInfo.logo_vertical_size }vh`,
                }"
                v-tooltip="{
                  content: thumbnailInfo.show_title_company,
                  trigger: 'hover',
                  placement: 'bottom',
                }"
              >
              <img v-else src="/static/logo360tovisit.png" height="30px" v-tooltip="'Go to 360tovisit'">
            </a>
          </el-col>

          <el-col class="hidden-sm-and-down" :xs="12" :md="12">
            <div v-if="!thumbnailEnable || (thumbnailInfo.show_tour_name !== false)">
              <h2>{{ trimText(project.name, 70) }}</h2>
            </div>
          </el-col>

          <el-col :xs="12" :md="6">
            <div class="action-buttons">
              <el-dropdown v-if="screenWidth > 767 && (!thumbnailEnable || (thumbnailInfo.show_language_selection !== false))" trigger="click" @command="changeLanguage" title="Change language">
                <span class="el-dropdown-link">
                  <span style="display: inline-block; line-height: 28px; position: relative; cursor: pointer;">
                    <img src="/static/icons/globe-64px.png" style="position: absolute; top: -14px; left: -25px; width: 20px;" />
                    <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in langs" :key="item.value" :command="item.value">
                    <span :class="item.value === $i18n.locale ? 'active-language' : ''">{{ item.text }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button circle size="small" icon="fa fa-file-text-o"
                v-if="scene.description && (!thumbnailEnable || (thumbnailInfo.show_pano_information !== false))"
                @click="openPanoInfo()"
                :title="$t('Open Panorama Info')"></el-button>
              <el-button icon="el-icon-picture" circle size="small"
                v-if="galleryEnable && screenWidth > 767"
                @click="openGallery()"
                :title="$t('Open gallery')"></el-button>
              <el-button icon="fa fa-map" circle size="small"
                v-if="project.address && screenWidth > 767 && (!thumbnailEnable || (thumbnailInfo.show_location_map !== false))"
                @click="openMap()"
                :title="$t('Open Location Map')"
                style="width: 32px; padding: 9px 7px;"></el-button>
              <el-button v-if="screenWidth > 767 && (!thumbnailEnable || (thumbnailInfo.show_tour_information !== false))" @click="openInfo()" icon="el-icon-info" circle size="small" :title="$t('Open Tour Info')"></el-button>
              <el-popover
                v-if="!thumbnailEnable || (thumbnailInfo.show_share_button !== false)"
                v-model="sharePopover"
                class="more-info-popover"
                placement="bottom"
                width="200"
                trigger="manual">
                <div>
                  <el-button type="primary" style="width: 100%; margin-top: 20px; background-color: #516eab; border: 0px;" @click="openBoxShare('https://www.facebook.com/sharer.php?u=' + viewUrl)">
                    <i class="fa fa-facebook"></i>
                    <span> {{ $t('Share on Facebook') }}</span>
                  </el-button>
                  <el-button type="primary" style="width: 100%; margin-top: 20px; margin-left: 0px; background-color: #29c5f6; border: 0px;" @click="openBoxShare('https://twitter.com/intent/tweet?text=' + project.slug)">
                    <i class="fa fa-twitter"></i>
                    <span> {{ $t('Share on Twitter') }}</span>
                  </el-button>
                  <a :href="emailShareLink" class="email-share-button" title="Share by Email" @click="trackShareEmail">
                    <i class="el-icon-message" style="margin-right: 5px"></i>
                    <span> {{ $t('Share by email') }}</span>
                  </a>
                </div>
                <el-button @click="handleClickShareButton()" slot="reference" icon="el-icon-share" circle size="small" title="Share this tour"></el-button>
              </el-popover>
              <el-popover
                v-if="screenWidth < 768 &&
                    (!thumbnailEnable ||
                      (thumbnailInfo.show_language_selection ||
                      thumbnailInfo.show_tour_information ||
                      thumbnailInfo.show_location_map))"
                class="more-info-popover"
                placement="bottom"
                width="150"
                trigger="click">
                <div>
                  <span v-if="!thumbnailEnable || (thumbnailInfo.show_language_selection !== false)" class="more-info-popover__item">
                    <img src="/static/globe.png" style="width: 16px; height: 16px; margin-right: 6px;" />
                    <el-select v-model="$i18n.locale" @change="changeLanguage"
                      size="mini"
                      class="lang-btn">
                      <el-option
                        v-for="item in langs"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </span>
                  <span v-if="!thumbnailEnable || (thumbnailInfo.show_tour_information !== false)" class="more-info-popover__item" @click="openInfo()" >
                    <i class="el-icon-info" size="small" style="margin-right: 8px"></i>
                    <span style="font-size: 12px">{{ $t('Open Tour Info') }}</span>
                  </span>
                  <span v-if="!thumbnailEnable || (thumbnailInfo.show_location_map !== false)" class="more-info-popover__item" @click="openMap()" >
                    <i class="fa fa-map" size="small" style="margin-right: 8px"></i>
                    <span style="font-size: 12px">{{ $t('Open Location Map') }}</span>
                  </span>
                  <span v-if="galleryEnable" class="more-info-popover__item" @click="openGallery()" >
                    <i class="el-icon-picture" size="small" style="margin-right: 8px"></i>
                    <span style="font-size: 12px">{{ $t('Open gallery') }}</span>
                  </span>
                </div>
                <span slot="reference" class="more-info-btn">
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </span>
              </el-popover>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="profileEnable" class="author-mobile">
        <span v-if="profileInfo.agent_full_name" @click="openProfile()" style="cursor: pointer">{{ $t('Virtual Tour by author', {author: profileInfo.agent_full_name}) }}</span>
      </div>
      <div v-show="(!thumbnailEnable || thumbnailInfo.show_arrow_navigation) && indexSceneCurrent > 0" @click="preScene()" class="navigation-btn arrow-left">
        <svg width="60px" height="80px" viewBox="0 0 50 80" xml:space="preserve">
            <polyline fill="none" stroke="#FFFFFF" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" points="
          25.63,75.8 0.375,38.087 25.63,0.375 "/>
        </svg>
      </div>
      <div v-show="(!thumbnailEnable || thumbnailInfo.show_arrow_navigation) && indexSceneCurrent < scenes.length - 1" @click="nextScene()" class="navigation-btn arrow-right">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60px" height="80px" viewBox="0 0 50 80" xml:space="preserve">
          <polyline fill="none" stroke="#FFFFFF" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" points="0.375,0.375 25.63,38.087 0.375,75.8"></polyline>
        </svg>
      </div>
      <div class="scene-list">
        <div class="bottom-actions">
          <div v-if="thumbnailEnable && thumbnailInfo.show_thumbnail && thumbnailInfo.show_hide_button" class="toggle-thumbnail-btn">
            <template v-if="thumbnailInfo.show_thumbnail_on_start">
              <div class="top-line"></div>
              <el-tooltip class="item" effect="dark" :content="$t('Hide thumbnails')" placement="top">
                <i class="el-icon-caret-bottom" @click="toggleThumbnail()"></i>
              </el-tooltip>
              <div class="top-line"></div>
            </template>
            <template v-else>
              <div class="bottom-line"></div>
              <el-tooltip class="item" effect="dark" :content="$t('Show thumbnails')" placement="top">
                <i class="el-icon-caret-top" @click="toggleThumbnail()"></i>
              </el-tooltip>
              <div class="bottom-line"></div>
            </template>
          </div>
          <div v-if="rotationEnable" style="display: flex; justify-content: flex-end; flex-grow: 1;">
            <img v-if="!enabledAutoRotate" @click="autoRotate()" src="/static/rotation.png" width="32" height="32" :title="$t('Click to Auto Play the Virtual Tour')">
          </div>
        </div>
        <transition name="slide-fade">
          <swiper v-show="scenes.length > 1 && (!thumbnailEnable || thumbnailEnable && thumbnailInfo.show_thumbnail && thumbnailInfo.show_thumbnail_on_start)" :options="swiperOption">
            <swiper-slide v-for="(item, index) in scenes.filter((item) => item.sceneUri)" :key="index" v-show="item.show_thumbnail">
              <div
                :class="{
                  'scene-box_inside': true,
                  active: scene.id === item.id
                }"
                :style="{ backgroundImage: 'url(' + encodeUrl((item.pano_type === 'video' ? videoUrl : imageUrl) + item.thumb) + ')' }"
                @click="handleClickThumbnail(item)">
                <div class="active-bar"></div>
                <el-tooltip class="item" effect="dark" :content="item.name" :disabled="item.name.length < 14" placement="top">
                  <p v-if="thumbnailEnable && thumbnailInfo.show_title_thumbnail">{{ trimText(item.name, 13) }}</p>
                </el-tooltip>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"><i class="fa fa-chevron-left fa-2x" aria-hidden="true"></i></div>
            <div class="swiper-button-next" slot="button-next"><i class="fa fa-chevron-right fa-2x" aria-hidden="true"></i></div>
          </swiper>
        </transition>
      </div>
    </template>
    <div v-if="notFound" class="not-found-actions">
      <div>
        <img src="/static/not-found-icon.jpg">
        <h3>{{ $t('Tour not found') }}</h3>
        <a class="el-button el-button--primary el-button--medium back-to-home" :href="homepage">{{ $t('Back to home') }}</a>
      </div>
    </div>
    <div
      v-else-if="maintenanceMode"
      class="not-found-actions"
      :style="{backgroundImage: project.screenshot ? `url(${encodeURI(imageUrl + project.screenshot)})` : null}"
    >
      <div v-if="!project.screenshot">
        <img src="/static/svg/maintenance.svg">
        <h3>The tour is undergoing maintenance</h3>
        <h3 v-if="project.show_time && maintenanceTimeRangeString">from {{ maintenanceTimeRangeString }}</h3>
        <h3 class="mt-0">Please come back later</h3>
        <a class="el-button el-button--primary el-button--medium back-to-home" :href="homepage">{{ $t('Back to home') }}</a>
      </div>
    </div>
    <transition name="fade">
      <div v-if="forbiddenProject" id="forbiddenScreen">
        <div
          class="background"
          :style="basicProjectInfo.config && basicProjectInfo.config.screen && basicProjectInfo.config.screen.background_image ? {
            backgroundImage: `url(${encodeURI(basicProjectInfo.config.screen.background_image)})`,
            backgroundSize: 'initial',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center center'
          } : {}"
        ></div>
        <transition name="fade">
          <div
            v-if="showSplashPopup"
            class="splash-popup"
            :style="{
              width: `${splashInfo.screen_width}%`,
              border: `${splashInfo.border_size}px solid ${splashInfo.border_color}`,
              backgroundColor: splashInfo.background_color
            }"
          >
            <div class="splash-popup__content" v-html="splashInfo.content"></div>
            <div v-if="splashInfo.show_continue_button">
              <el-button
                type="primary"
                :style="{
                  backgroundColor: splashInfo.continue_btn_bg_color,
                  borderColor: splashInfo.continue_btn_border_color,
                  color: splashInfo.continue_btn_color
                }"
                @click="continueFollowSplash()"
              >{{ splashInfo.continue_btn_text || $t('Continue') }}</el-button>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLoginPopup"
            class="authentication-box"
            :style="basicProjectInfo.config ? {
              width: `${basicProjectInfo.config.popup.width}vw`,
              border: `${basicProjectInfo.config.popup.border_size}px solid ${basicProjectInfo.config.popup.border_color}`,
              backgroundColor: basicProjectInfo.config.popup.background_color,
              backgroundImage: basicProjectInfo.config.popup.background_type === 'image' ? `url(${basicProjectInfo.config.popup.background_image})` : ''
            } : {}">
            <h2 class="project-name">
              <span :style="basicProjectInfo.config ? {color: basicProjectInfo.config.popup.tour_color} : {}">{{ basicProjectInfo.name }}</span>
              <img
                v-if="profileInfo && profileInfo.avatar"
                :src="imageUrl + profileInfo.avatar"
                class="profile-avatar"
              >
            </h2>
            <div v-if="profileInfo.agent_full_name" class="profile-box">
              <p class="author-name" :style="{color: basicProjectInfo.config.popup.public_profile_color}">by {{ profileInfo.agent_full_name }}</p>
              <el-button
                v-if="profileInfo.email"
                round
                size="mini"
                :style="{
                  color: basicProjectInfo.config.popup.public_profile_color,
                  borderColor: basicProjectInfo.config.popup.public_profile_color
                }"
                @click="openEmailto(profileInfo.email)"
              >
                <i class="fa fa-envelope-o" aria-hidden="true"></i>
                {{ profileInfo.email }}
              </el-button>
              <el-button
                v-if="profileInfo.mobile_phone_number"
                round size="mini"
                :style="basicProjectInfo.config ? {
                  color: basicProjectInfo.config.popup.public_profile_color,
                  borderColor: basicProjectInfo.config.popup.public_profile_color
                } : {}"
              >
                <i class="fa fa-mobile" aria-hidden="true"></i>
                {{ profileInfo.mobile_phone_number }}
              </el-button>
            </div>
            <div class="authen-form">
              <div v-if="basicProjectInfo.config" class="pa-2 ma-2" v-html="basicProjectInfo.config.popup.content"></div>
              <el-form
                v-if="loginType === 'visitor'"
                ref="loginForm"
                :model="loginForm"
                :rules="loginRules()"
                @submit.native.prevent="submitLoginForm"
              >
                <el-form-item prop="email">
                  <el-input
                    v-model="loginForm.email"
                    :placeholder="$t('Email')"
                    :rules="[
                      { required: true, message: 'Code is required' }
                    ]"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="basicProjectInfo.config && !basicProjectInfo.config.login_without_password" prop="password">
                  <el-input v-model="loginForm.password" type="password" :placeholder="$t('Password')"></el-input>
                </el-form-item>
                <el-button
                  type="primary"
                  native-type="submit"
                  size="medium"
                  :style="basicProjectInfo.config ? {
                    border: `1px solid ${basicProjectInfo.config.popup.btn_border_color}`,
                    background: basicProjectInfo.config.popup.btn_background,
                    color: basicProjectInfo.config.popup.btn_color,
                    width: '100%'
                  } : {}"
                >{{ ((basicProjectInfo.config || {}).popup || {}).btn_text || $t('Start Virtual Tour') }}</el-button>
              </el-form>
              <el-form
                v-else
                ref="loginForm"
                :model="loginForm"
                :rules="salerRules"
                @submit.native.prevent
              >
                <el-form-item prop="email">
                  <el-input v-model="loginForm.email" :placeholder="$t('Email')"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input v-model="loginForm.password" type="password" :placeholder="$t('Password')"></el-input>
                </el-form-item>
                <el-button
                  type="primary"
                  native-type="submit"
                  size="medium"
                  :style="{
                    border: `1px solid ${basicProjectInfo.config.popup.btn_border_color}`,
                    background: basicProjectInfo.config.popup.btn_background,
                    color: basicProjectInfo.config.popup.btn_color,
                    width: '100%'
                  }"
                  @click="submitSalerForm"
                >{{ basicProjectInfo.config.popup.btn_text || $t('Start Virtual Tour') }}</el-button>
              </el-form>
            </div>
            <div v-if="basicProjectInfo.config && basicProjectInfo.config.access_on_demand" class="request-form">
              <h4>{{ $t('Or request access to the author') }}</h4>
              <el-form ref="requestForm" :model="requestForm" :rules="requestFormRules" @submit.native.prevent>
                <el-form-item prop="name">
                  <el-input v-model="requestForm.name" size="small" :placeholder="$t('Name')"></el-input>
                </el-form-item>
                <el-form-item prop="email">
                  <el-input v-model="requestForm.email" size="small" :placeholder="$t('Email')"></el-input>
                </el-form-item>
                <el-form-item prop="phone">
                  <el-input v-model="requestForm.phone" size="small" :placeholder="$t('Phone')"></el-input>
                </el-form-item>
                <el-button
                  type="primary"
                  native-type="submit"
                  size="small"
                  block
                  @click="sendRequestDemand()">{{ $t('Send Request') }}</el-button>
              </el-form>
            </div>
          </div>
          <div
            v-else-if="showVerifyPopup"
            class="authentication-box"
            :style="basicProjectInfo.config ? {
              width: `${basicProjectInfo.config.popup.width}vw`,
              border: `${basicProjectInfo.config.popup.border_size}px solid ${basicProjectInfo.config.popup.border_color}`,
              backgroundColor: basicProjectInfo.config.popup.background_color,
              backgroundImage: basicProjectInfo.config.popup.background_type === 'image' ? `url(${basicProjectInfo.config.popup.background_image})` : ''
            } : {}">
            <div class="px-10">
              <h1 class="text-center mb-4" style="color: #841F3F">Wines of Portugal Virtual Experience</h1>
              <img src="/static/icons/wipo_theme/sponsor_black.png" width="120px">
              <p class="text-center mt-8">We sent a confirmation code to <b>{{ loginForm.email }}</b>, copy and paste the code to continue your registration.</p>
            </div>
            <el-form
              @submit.native.prevent="sendVerifyVisitorForm"
              :model="verifyVisitorForm"
              ref="verifyVisitorForm"
              class="d-flex align-items-center"
            >
              <el-form-item prop="code" size="medium" class="flex-grow-grow-1 mr-2"
                :rules="[
                  { required: true, message: 'Code is required' }
                ]"
              >
                <el-input type="text" v-model.number="verifyVisitorForm.code" size="medium" ref="verifyVisitorFormFirstInput"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  :loading="verifyVisitorFormLoading"
                  type="primary"
                  native-type="submit"
                  size="medium"
                  :style="{
                    border: `1px solid ${basicProjectInfo.config.popup.btn_border_color}`,
                    background: basicProjectInfo.config.popup.btn_background,
                    color: basicProjectInfo.config.popup.btn_color,
                    width: '100%'
                  }"
                  @click="submitSalerForm"
                >Enter</el-button>
              </el-form-item>
            </el-form>
          </div>
        </transition>
      </div>
    </transition>
    <div v-if="this.salerToken" class="online-visitors-box">
      <div class="d-flex justify-content-end mb-4">
        <el-button
          v-if="salerToken && (syncViewSession || offlineVisitor)"
          plain
          size="small"
          @click="toggleCartBox"
        >
          <i class="el-icon-goods"></i>
          <span>Cart ({{ cartCurrentNumber > 9 ? '9+' : cartCurrentNumber }})</span>
        </el-button>
        <el-button type="primary" size="small" @click="showListVisitorOnline = !showListVisitorOnline">
          <span>{{ $t('VIP sessions') }}</span>
          <i v-if="showListVisitorOnline" class="el-icon-arrow-down"></i>
          <i v-else class="el-icon-arrow-right"></i>
        </el-button>
      </div>
      <div v-if="showListVisitorOnline" class="visitor-list pa-2">
        <template v-if="visitorList.length">
          <div class="d-flex">
            <el-button
              size="mini"
              class="mr-1"
              plain
              style="padding: 7px 8px"
              @click="toggleSortListVisitor()"
            >
              <i v-if="visitorListSort === 1" class="el-icon-caret-bottom"></i>
              <i v-else class="el-icon-caret-top"></i>
            </el-button>
            <el-input v-model="visitorListSearch" placeholder="Search" size="mini">
              <i
                v-if="visitorListSearch"
                slot="suffix"
                class="el-input__icon el-icon-close"
                style="color: #000; cursor: pointer;"
                @click="visitorListSearch = ''"
              ></i>
              <i v-else slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div v-if="visitorListFiltered.length" class="visitor-list__content">
            <div
              v-for="visitor in visitorListFiltered"
              :key="visitor.id"
              class="d-flex justify-content-space-between my-2"
            >
              <p class="d-flex align-items-center ma-0">
                <el-button v-if="visitor.connection_id" size="mini" type="success" class="mr-1">
                  <i class="el-icon-circle-check-outline"></i> ON
                </el-button>
                <el-button v-else size="mini" type="danger" class="mr-1">
                  <i class="el-icon-circle-close-outline"></i> OFF
                </el-button>
                <span>{{ visitor.name }}</span>
              </p>
              <el-button
                v-if="visitor.connection_id"
                size="mini"
                :loading="visitor.connection_status === 'connecting'"
                :disabled="visitor.connection_status === 'connected' || !!syncViewSession || !!offlineVisitor"
                @click="connectSession(visitor)"
              >
                <span v-if="visitor.connection_status" class="text-capitalize">{{ visitor.connection_status }}</span>
                <span v-else>Connect</span>
              </el-button>
              <el-button
                v-else
                size="mini"
                :disabled="visitor.connection_status === 'connected' || !!syncViewSession || !!offlineVisitor"
                @click="connectOfflineVisitor(visitor)"
                class="text-capitalize"
              >{{ visitor.connection_status || 'Connect' }}</el-button>
            </div>
          </div>
          <p v-else class="text-center">{{ $t('No VIP online now') }}</p>
        </template>
        <p v-else class="text-center"><span v-if="!visitorOnlineLoading">{{ $t('No VIP online now') }}</span></p>
        <div v-if="visitorOnlineLoading" class="d-flex justify-content-center">
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </div>
    <div v-if="syncViewSession || offlineVisitor" class="live-view-status">
      <el-button type="primary" size="medium">
        <span v-if="connectedSaler">{{ $t('Connected with a SA') }}</span>
        <span v-else-if="connectedVisitor">{{ $t('Connected with') }} {{ connectedVisitor.name }}</span>
        <span v-else-if="offlineVisitor">{{ $t('Connected with') }} {{ offlineVisitor.name }}</span>
      </el-button>
      <el-button type="danger" plain size="medium" @click="stopSession()">{{ $t('Stop') }}</el-button>
      <template v-if="connectedVisitor">
        <el-button
          v-if="visitorControl"
          type="danger"
          plain
          size="medium"
          @click="toggleVisitorControl()"
        >{{ $t('Disable user control') }}</el-button>
        <el-button
          v-else
          type="primary"
          plain
          size="medium"
          @click="toggleVisitorControl()"
        >{{ $t('Allow user control') }}</el-button>
      </template>
    </div>
    <transition name="fade">
      <div v-if="dialogHotspot && hotspotCurrent" class="popup-wrapper" @click="dialogHotspot = false">
        <div
          class="popup pa-4"
          :style="hotspotCurrent.metadata ? {
            width: `${hotspotCurrent.metadata.popup_width}px`,
            background: hotspotCurrent.metadata.popup_background,
            border: `${hotspotCurrent.metadata.popup_border_size}px solid ${hotspotCurrent.metadata.popup_border_color}`,
            'border-radius': `${hotspotCurrent.metadata.popup_border_radius}px`
          } : {}"
          @click.stop
        >
          <div v-if="hotspotCurrent.metadata ? hotspotCurrent.metadata.closed_btn : true" class="hotspot-box-info__closed-btn d-flex justify-content-end mb-2">
            <i
              class="el-icon-close cursor-pointer"
              style="font-size: 18px"
              v-tooltip="$t('Close popup')"
              @click.stop="dialogHotspot = false"
            ></i>
          </div>
          <div class="hotspot-box-info">
            <div v-if="hotspotCurrent.info" v-html="hotspotCurrent.info.content"></div>
            <img v-if="hotspotCurrent.image" :src="imageUrl + hotspotCurrent.image.imageUrl" width="100%">
          </div>
        </div>
      </div>
    </transition>
    <el-dialog class="project-info-dialog" title="Gallery" :visible.sync="showGallery" :width="dialogWidth">
      <p v-show="galleryContent.length === 0" class="text-center">{{ $t('No images in gallery') }}</p>
      <el-carousel v-show="galleryContent.length" trigger="click" height="70vh" :autoplay="false">
        <el-carousel-item v-for="(image, index) in galleryContent" :key="index" style="text-align: center; display: flex; justify-content: center; align-items: center;">
          <img :src="imageUrl + image.url" @load="checkSizeTypePicture">
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <el-dialog class="project-info-dialog" :title="$t('Location')" :visible.sync="showMap" :width="dialogWidth">
      <div style="width: 100%; height: 50vh;">
        <GmapMap
          class="model-content__gmapMap"
          :span="24"
          :center="mapOptions.marker.position"
          :zoom="mapOptions.zoom"
          map-type-id="roadmap"
          style="height: 100%">
          <gmap-info-window :position="mapOptions.marker.position" :opened="true">{{ project.address }}</gmap-info-window>
        </GmapMap>
      </div>
    </el-dialog>
    <el-dialog class="project-info-dialog" :title="project.name" :visible.sync="showInfo" :width="dialogWidth">
      <el-row>
        <el-col :span="24" v-if="project.description || project.address">
          <h4 v-show="project.description" style="margin: 0px 0px 5px 0px">{{ $t('Tour Description') }}</h4>
          <p v-show="project.description" style="margin: 0px 0px 5px 0px" v-html="project.description"></p>
          <h4 v-show="project.address" style="margin: 5px 0px 5px 0px">{{ $t('Address') }}</h4>
          <p v-show="project.address" style="margin: 0px 0px 5px 0px">{{ project.address }}</p>
        </el-col>
        <el-col
          v-for="(field, key) in additionalFields"
          :key="key"
          :span="24"
        >
          <template v-if="field !== null">
            <h4 v-if="field && field.length" style="margin: 5px 0px 5px 0px">{{ key }}</h4>
            <p v-if="Array.isArray(field)" style="margin: 0px 0px 5px 0px">
              <span v-for="fieldElement in field" :key="fieldElement" style="margin-right: 20px">
                <i class="el-icon-check" style="color: #67C23A"></i> {{ fieldElement }}
              </span>
            </p>
            <p v-else tyle="margin: 0px 0px 5px 0px">{{ field }}</p>
          </template>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog class="project-info-dialog" :title="$t('About author')" :visible.sync="showProfile" :width="dialogWidth">
      <el-row>
        <el-col :xs="24" :md="6">
          <img :src="this.profileInfo.avatar ? (imageUrl + this.profileInfo.avatar) : '/static/avatar-default.jpg'" style="width: 150px; height: 150px; border-radius: 50%;">
        </el-col>
        <el-col :xs="24" :md="18">
          <h4 style="margin: 0px 0px 5px 0px">{{ $t('Name') }}</h4>
          <p style="margin: 0px 0px 5px 0px">{{ this.profileInfo.agent_full_name }}</p>
          <h4 v-if="this.profileInfo.company_name && this.profileInfo.company_name !== 'null'" style="margin: 5px 0px 5px 0px">{{ $t('Company') }}</h4>
          <p v-if="this.profileInfo.company_name && this.profileInfo.company_name !== 'null'" style="margin: 0px 0px 5px 0px">{{ this.profileInfo.company_name }}</p>
          <div v-if="this.profileInfo.email && this.profileInfo.email !== 'null'">
            <h4 style="margin: 5px 0px 5px 0px">{{ $t('Email') }}</h4>
            <p style="margin: 0px 0px 5px 0px"><a :href="`mailto:${this.profileInfo.email}`">{{ this.profileInfo.email }}</a></p>
          </div>
          <div v-if="this.profileInfo.website && this.profileInfo.website !== 'null'">
            <h4 style="margin: 5px 0px 5px 0px">{{ $t('Website') }}</h4>
            <p style="margin: 0px 0px 5px 0px"><a :href="formatLink(this.profileInfo.website)" target="_blank">{{ this.profileInfo.website }}</a></p>
          </div>
          <div v-if="this.profileInfo.office_phone_number && this.profileInfo.office_phone_number !== 'null'">
            <h4 style="margin: 5px 0px 5px 0px">{{ $t('Phone') }}</h4>
            <p style="margin: 0px 0px 5px 0px">{{ this.profileInfo.office_phone_number }}</p>
          </div>
          <div v-if="this.profileInfo.mobile_phone_number && this.profileInfo.mobile_phone_number !== 'null'">
            <h4 style="margin: 5px 0px 5px 0px">{{ $t('Mobile') }}</h4>
            <p style="margin: 0px 0px 5px 0px">{{ this.profileInfo.mobile_phone_number }}</p>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog class="project-info-dialog" :title="scene.name" :visible.sync="showPanoInfo" :width="dialogWidth">
      <el-row>
        <el-col :span="24">
          <p v-if="scene.description">{{ scene.description }}</p>
          <p v-else class="text-center">{{ $t('No description') }}</p>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      class="product-content-dialog"
      :visible.sync="showProductContent"
      :fullscreen="true"
    >
      <ProductContent
        v-if="productContent"
        :content-type="productContent.type"
        :content="productContent.data"
        @close="showProductContent = false"
      />
    </el-dialog>
    <div v-if="showProductDialog" class="product-popup pa-4">
      <div class="close-btn d-flex justify-content-end">
        <i class="el-icon-close" @click="closeProductPopup()"></i>
      </div>
      <Product
        v-if="hotspotCurrent && hotspotCurrent.product_id"
        :product-id="hotspotCurrent.product_id"
        :cart-available="salerToken && (syncViewSession || offlineVisitor)"
        @submitOrder="handleSubmitOrder"
        @productFetched="handleProductFetched"
        @variantSelected="handleVariantSelected"
        @showFullContent="handleShowProductContent"
      />
    </div>
    <transition name="scale">
      <div v-show="showCartPopup" class="cart-box pa-4">
        <div class="close-btn d-flex justify-content-end">
          <i class="el-icon-close" @click="showCartPopup = false"></i>
        </div>
        <Cart
          :project-id="project.id"
          :user-connected="offlineVisitor || onlineVisitor"
          :sa="saler"
          ref="cart"
          @changeAmount="cartCurrentNumber = $event"
          @openConfirm="handleOpenOrderConfirm"
          @closeConfirm="handleCloseOrderConfirm"
          @orderConfirmed="handleOrderConfirmed"
        />
      </div>
    </transition>
    <transition name="fade">
      <div v-show="showVisitorCartPopup" class="cart-box visitor-cart-box pa-4">
        <div class="close-btn d-flex justify-content-end">
          <i class="el-icon-close" @click="showVisitorCartPopup = false"></i>
        </div>
        <Cart
          :project-id="project.id"
          :user-connected="visitor"
          view-mode="visitor"
          ref="visitorCart"
        />
      </div>
    </transition>
    <div
      v-if="showVideoCallBox"
      :class="{'video-call-wrapper d-flex justify-content-center align-items-center flex-direction-column': true, 'pip-mode': videoCallPipMode}"
      @click="handleClickOutside"
    >
      <div class="control-group d-flex justify-content-end">
        <img
          :src="videoCallPipMode ? '/static/icons/expand.svg' : '/static/icons/minimize.svg'"
          class="mr-2"
          style="width: 20px; padding: 4px;"
          @click.stop="toggleMiniVideoCall"
        />
        <i class="el-icon-close" @click.stop="showConfirmCloseVideoCall"></i>
      </div>
      <iframe v-if="videoCallUrl" :src="videoCallUrl" sandbox="allow-forms allow-scripts allow-same-origin" allow="microphone; camera; fullscreen"></iframe>
    </div>
    <el-dialog :visible.sync="showMeetingForm">
      <el-form @submit.native.prevent="createMeeting" :model="meetingForm" ref="meetingForm">
        <el-form-item :label="$t('Name')" prop="name" size="medium"
          :rules="[
            { required: true, message: 'Name is required' }
          ]"
        >
          <el-input type="text" v-model.number="meetingForm.name" ref="meetingForm_name" autofocus></el-input>
        </el-form-item>
        <el-form-item :label="$t('Email')" prop="email"
          :rules="[
            { required: true, type: 'email', message: 'Email is required' }
          ]"
        >
          <el-input type="text" v-model="meetingForm.email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            style="width: 100%"
            native-type="submit">Call</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="showVisitorProfileForm"
      :before-close="submitVisitorProfile"
      :width="dialogWidth"
      custom-class="rounded-dialog"
    >
      <h2 class="mt-0 mb-2">Fill out the following form to complete your registration</h2>
      <el-form
        @submit.native.prevent="submitVisitorProfile"
        :model="visitorProfileForm"
        ref="visitorProfileForm"
        class="mt-8"
      >
        <el-row :gutter="20">
          <el-col :span="24" :md="12">
            <el-form-item :label="$t('First name')" prop="first_name" :rules="[{ required: true, message: $t('Field is required') }]">
              <el-input type="text" v-model="visitorProfileForm.first_name" size="medium" ref="visitorProfileFormFirstInput"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12">
            <el-form-item :label="$t('Last name')" prop="last_name" :rules="[{ required: true, message: $t('Field is required') }]">
              <el-input type="text" v-model="visitorProfileForm.last_name" size="medium"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" :md="12">
            <el-form-item :label="$t('Company')" prop="company" :rules="[{ required: true, message: $t('Field is required') }]">
              <el-input type="text" v-model="visitorProfileForm.company" size="medium"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12">
            <el-form-item :label="$t('State')" prop="state" :rules="[{ required: true, message: $t('Field is required') }]">
              <el-select
                v-model="visitorProfileForm.state"
                placeholder="State"
                size="medium"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in ['D.C.', 'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'Other/Overseas']"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('Job title')" prop="job_title" :rules="[{ required: true, message: $t('Field is required') }]">
          <el-input type="text" v-model="visitorProfileForm.job_title" size="medium"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Category (select all that apply)')" prop="role" :rules="[{ required: true, message: $t('Field is required') }]">
          <el-select
            v-model="visitorProfileForm.role"
            placeholder="Enter or select"
            size="medium"
            multiple
            filterable
            allow-create
            default-first-option
            style="width: 100%"
          >
            <el-option
              v-for="item in ['Importer', 'Distributor', 'Retailer', 'Hotel/Bar/Restaurant', 'Wine Educator', 'Wine Consultant', 'Press', 'Other']"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <p style="color: #F2994A">All information provided will be kept confidential. We will not disclose your personal information to a third party without your consent.</p>
        <el-button
          :loading="visitorProfileFormLoading"
          type="primary"
          size="medium"
          style="width: 100%"
          native-type="submit"
          :style="basicProjectInfo && basicProjectInfo.config && basicProjectInfo.config.popup ? {
            border: `1px solid ${basicProjectInfo.config.popup.btn_border_color}`,
            background: basicProjectInfo.config.popup.btn_background,
            color: basicProjectInfo.config.popup.btn_color,
            width: '100%'
          } : {}">Submit</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import KRPANO from '@/plugins/krpano'
import axios from 'axios'
import { forEach, findIndex, debounce, cloneDeep } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ls from 'local-storage'
import Product from '@/components/preview/Product'
import Cart from '@/components/preview/Cart'
import ProductContent from '@/components/preview/elements/ProductContent'
export default {
  name: 'Tour',
  components: {
    swiper,
    swiperSlide,
    Product,
    Cart,
    ProductContent,
    Wine: () => import('@/components/preview/themeLayouts/Wine'),
    WineMain: () => import('@/components/preview/themeLayouts/WineMain')
  },
  data () {
    return {
      homepage: 'http://360tovisit.com',
      loading: false,
      imageUrl: process.env.IMAGE_PATH,
      videoUrl: process.env.VIDEO_PATH,
      dialogWidth: screen.width > 500 ? '60%' : '90%',
      screenWidth: screen.width,
      indexSceneCurrent: 0,
      project: {
        name: '',
        description: '',
        address: '',
        image: ''
      },
      scenes: [],
      scene: {},
      hotspotCurrent: {
        name: '',
        content: ''
      },
      notFound: false,
      maintenanceMode: false,
      forbiddenProject: false,
      showSplashPopup: false,
      showLoginPopup: false,
      projectToken: '',
      salerToken: '',
      salerId: '',
      saler: null,
      visitor: null,
      visitorId: '',
      basicProjectInfo: {
        name: ''
      },
      dialogHotspot: false,
      viewUrl: window.location.href,
      sharePopover: false,
      popup: {
        status: false,
        resizable: true,
        toolbar: false,
        menubar: false,
        scrollbars: false,
        location: false,
        directories: false,
        width: 600,
        height: 350,
        top: 0,
        left: 0,
        window: undefined,
        interval: null
      },
      swiperOption: {
        slidesPerView: 8,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          2560: {
            slidesPerView: 10,
            spaceBetween: 10
          },
          1440: {
            slidesPerView: 7,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 5
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 5
          },
          480: {
            slidesPerView: 3,
            spaceBetween: 5
          },
          375: {
            slidesPerView: 2,
            spaceBetween: 5
          }
        }
      },
      gallerySwiperOption: {
        navigation: {
          nextEl: '.gallery-swiper-button-next',
          prevEl: '.gallery-swiper-button-prev'
        }
      },
      profileEnable: false,
      profileInfo: {
        id: '',
        company_name: '',
        agent_full_name: '',
        avatar: ''
      },
      galleryEnable: false,
      thumbnailEnable: false,
      thumbnailInfo: {
        show_thumbnail: true,
        show_hide_button: true,
        show_thumbnail_on_start: true
      },
      splashEnable: false,
      splashInfo: {},
      rotationEnable: false,
      rotationInfo: {
        auto: false,
        speed: '3.0'
      },
      galleryContent: [],
      showGallery: false,
      showMap: false,
      showInfo: false,
      showProfile: false,
      showPanoInfo: false,
      mapOptions: {
        zoom: 10,
        mapOptions: {},
        marker: {
          position: { lat: 48.8735, lng: 2.2951 },
          title: 'Click to zoom'
        }
      },
      enabledAutoRotate: false,
      autoNextScene: {},
      additionalFields: {},
      loginForm: {
        email: '',
        password: ''
      },
      salerRules: {
        email: [
          { required: true, message: this.$t('Email is required') }
        ],
        password: [
          { required: true, message: this.$t('Password is required') }
        ]
      },
      loginType: 'visitor',
      requestForm: {
        name: '',
        email: '',
        phone: ''
      },
      requestFormRules: {
        name: [
          { required: true, message: this.$t('Name is required') }
        ],
        email: [
          { required: true, message: this.$t('Email is required') }
        ]
      },
      messageWarning: '',
      privateEnable: false,
      onHotspotView: false,
      checkPanoLoadingProgress: null,
      panoLoading: false,
      socket: null,
      showListVisitorOnline: true,
      visitorOnlineLoading: false,
      visitorList: [],
      syncViewSession: null,
      connectedSaler: null,
      visitorControl: true,
      onRemoteView: false,
      visitorListSort: 1,
      visitorListSearch: '',
      onRemoteViewTimeout: null,
      showProductContent: false,
      productContent: null,
      showProductDialog: false,
      showCartPopup: false,
      showVisitorCartPopup: false,
      cartCurrentNumber: 0,
      showCartTooltip: false,
      cartTooltipContent: '',
      offlineVisitor: null,
      onlineVisitor: null,
      disableControl: false,
      videoCallUrl: '',
      showVideoCallBox: false,
      videoCallPipMode: false,
      showMeetingForm: false,
      meetingForm: {
        name: '',
        email: '',
        meetingNumber: '',
        password: '',
        role: 0
      },
      meetingFormRules: {
        name: [
          { required: false, message: this.$t('Field required'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('Field required'), trigger: 'blur' }
        ]
      },
      showVerifyPopup: false,
      showVisitorProfileForm: false,
      verifyVisitorFormLoading: false,
      visitorProfileFormLoading: false,
      verifyVisitorForm: {
        code: ''
      },
      visitorProfileForm: {
        first_name: '',
        last_name: '',
        company: '',
        job_title: '',
        role: '',
        state: ''
      }
    }
  },
  computed: {
    ...mapGetters(['langs']),
    ...mapGetters('icon', ['icons']),
    emailShareLink () {
      return 'mailto:?subject=Here is a very nice 360° Virtual Tour I have made with 360tovisit.com. Please visit the link below!&body=Hello%2C I made this very nice 360° Virtual Tour. To visit it%2C click on the link below: %0A' + window.location.href + ' %0A If  you want to be able to do the same%2C visit www.360tovisit.com. Regards'
    },
    isMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    connectedVisitor () {
      if (!this.syncViewSession) {
        return null
      } else {
        return this.visitorList.find((item) => item.connection_id === this.syncViewSession.connection_id)
      }
    },
    visitorListFiltered () {
      if (this.visitorListSearch) {
        return this.visitorList.filter((item) => !item.connection_id && item.name.toLowerCase().includes(this.visitorListSearch.toLowerCase()))
      } else {
        return this.visitorList.filter((item) => item.connection_id || item.connection_status === 'connected')
      }
    },
    maintenanceTimeRangeString () {
      if (this.project && this.project.start_date && this.project.end_date) {
        let startObj = new Date(this.project.start_date)
        let endObj = new Date(this.project.end_date)
        return `${startObj.toLocaleTimeString()} ${startObj.toDateString()} to ${endObj.toLocaleTimeString()} ${endObj.toDateString()}`
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapActions('icon', ['fetchListIcons']),
    handleClickMenuFromTheme (index) {
      if (this.scenes.length >= index) {
        this.handleClickThumbnail(this.scenes[index])
      }
    },
    loginRules () {
      if (this.basicProjectInfo && this.basicProjectInfo.config && this.basicProjectInfo.config.login_verify) {
        return {
          email: [
            { required: true, message: this.$t('Email is required') },
            { type: 'email', message: 'Please input correct email address', trigger: ['blur'] }
          ]
        }
      } else {
        return {
          email: [
            { required: true, message: this.$t('Email or Username is required') }
          ],
          password: [
            { required: !this.basicProjectInfo.config.login_without_password, message: this.$t('Password is required') }
          ]
        }
      }
    },
    changeLanguage (value) {
      this.$i18n.locale = value
      ls.set('lang', value)
    },
    init () {
      var vars = {}

      this.panoview = KRPANO('_preview')
      this.panoview.init('pano', '/static/libraries/view.xml', vars)

      // start first scene
      if (!Object.keys(this.$route.query).length) {
        /** if no queries on url, can go straight to first pano */
        this.loadFirstScene()
      } else {
        /** otherwise, a bit deplay to check if there is preset first pano */
        setTimeout(() => {
          this.loadFirstScene()
        }, 80)
      }

      if (document.addEventListener) {
        document.addEventListener('onloadscenecompleted', () => {
          // RELATIVE DOCUMENTS
          // https://krpano.com/docu/actions/#stagescale
          // https://krpano.com/forum/wbb/index.php?page=Thread&threadID=10707
          // if (this.isMobile) {
          //   this.panoview.krpano().set('stagescale', 1.2)
          // }

          if (!this.thumbnailEnable || (this.thumbnailEnable && this.thumbnailInfo.show_poi === undefined) || (this.thumbnailEnable && this.thumbnailInfo.show_poi)) {
            for (let i = 0; i < this.scene.hotspots.length; i++) {
              this.showHotspot(this.scene.hotspots[i])
            }
          }
          this.loading = false

          // check poi_id param on uri
          if (this.$route.query.poi_id) {
            let poi = this.scene.hotspots.find((item) => item.id === parseInt(this.$route.query.poi_id))
            if (poi) {
              this.handleClickHotspot(poi)
            }
          }

          setTimeout(() => {
            this.addEventOnclickThemeBtn()
          }, 1000)

          // Check for auto open POI
          this.scene.hotspots.every((poi) => {
            if (poi.metadata && poi.metadata.open_at_start) {
              this.handleClickHotspot(poi)
              if (poi.metadata.duration) {
                setTimeout(() => {
                  if (this.hotspotCurrent.id === poi.id) {
                    this.dialogHotspot = false
                  }
                }, poi.metadata.duration * 1000)
              }
              return false
            } else {
              return true
            }
          })
        }, false)
        document.addEventListener('onclick', () => {
          this.handleOnclickPano()
        })
      }

      // Check autorotation plugin
      if (this.rotationInfo.auto) {
        this.autoRotate()
      }
    },
    loadFirstScene () {
      if (!this.loading) {
        let vars = {}
        this.loading = true

        let viewObject = {}
        if (this.scene.initial_view instanceof Object) {
          Object.assign(viewObject, this.scene.initial_view)
        }
        if (this.scene.view_settings) {
          Object.assign(viewObject, {
            fovmin: this.scene.view_settings.fovmin,
            fovmax: this.scene.view_settings.fovmax,
            distortion: this.scene.view_settings.distortion,
            distortionfovlink: this.scene.view_settings.distortionfovlink
          })
        }

        if (this.scene.pano_type === 'video') {
          this.panoview.loadVideo(this.videoUrl + this.scene.sceneUri, '', vars, this.scene.blend_mode, viewObject)
        } else {
          let sceneUri = this.scene.sceneOptimize
          let xml = null
          if (this.scene.sceneUri && this.scene.pano_type === 'multi') {
            sceneUri = this.scene.sceneUri
            xml = this.scene.xml.replace(/url="/g, 'url="' + this.imageUrl + this.scene.sceneUri + '/')
          }
          this.runCheckLoadPanoProgress()
          this.panoview.loadScene(this.imageUrl + sceneUri, vars, xml, this.scene.blend_mode, viewObject)
        }
      }
    },
    focusView (view, motionType = 'smooth(120,120,90)') {
      this.panoview.krpano().call(`lookto(${view.hlookat},${view.vlookat},${view.fov},${motionType})`)
    },
    showHotspot (hotspot) {
      switch (hotspot.type) {
        case 'pip':
          this.showImageHotspot(hotspot)
          break
        case 'patch':
          this.showNadirPatch(hotspot)
          break
        case 'html':
          this.showHtmlHotspot(hotspot)
          break
        default:
          this.showIconHotspot(hotspot)
          break
      }
    },
    showNadirPatch (hotspot) {
      let name = `hp-${hotspot.id}`
      if (hotspot.image.imageUrl) {
        let imageWidth = hotspot.iconWidth ? hotspot.iconWidth : 200
        this.panoview.krpano().set(`hotspot[${name}].url`, this.imageUrl + hotspot.image.imageUrl)
        this.panoview.krpano().set(`hotspot[${name}].width`, imageWidth)
        this.panoview.krpano().set(`hotspot[${name}].height`, 'prop')
        this.panoview.krpano().set(`hotspot[${name}].distorted`, true)
      } else {
        let imageWidth = hotspot.iconWidth ? hotspot.iconWidth : 200
        this.panoview.krpano().set(`hotspot[${name}].url`, this.imageUrl + hotspot.icon.iconUrl)
        this.panoview.krpano().set(`hotspot[${name}].width`, imageWidth)
        this.panoview.krpano().set(`hotspot[${name}].height`, 'prop')
        this.panoview.krpano().set(`hotspot[${name}].distorted`, true)
      }
      if (hotspot.nadir_patch_position) {
        this.panoview.krpano().set(`hotspot[${name}].ath`, 0)
        this.panoview.krpano().set(`hotspot[${name}].atv`, -90)
      } else {
        this.panoview.krpano().set(`hotspot[${name}].ath`, 0)
        this.panoview.krpano().set(`hotspot[${name}].atv`, 90)
      }
      this.panoview.krpano().set(`hotspot[${name}].alpha`, hotspot.alpha)
      this.panoview.krpano().set(`hotspot[${name}].zorder`, hotspot.zorder)
      this.panoview.krpano().set(`hotspot[${name}].capture`, false)
      this.panoview.krpano().set(`hotspot[${name}].mipmapping`, true)
      if (hotspot.enable_title && hotspot.name) {
        this.panoview.krpano().set(`hotspot['${name}'].onhover`, `showtext(${hotspot.name.replace(/[!'(),*]/g, (c) => '%' + c.charCodeAt(0).toString(16))}, STYLE4)`)
      }
      this.panoview.krpano().set(`hotspot['${name}'].onclick`, () => {
        this.trackClickHotspot(hotspot)
      })
      this.panoview.krpano().call(`addhotspot(${name})`)
    },
    showImageHotspot (hotspot) {
      let name = 'hp-' + hotspot.id
      this.panoview.krpano().set("hotspot['" + name + "'].url", '/static/loading.gif')
      this.panoview.krpano().set("hotspot['" + name + "'].width", 80)
      this.panoview.krpano().set("hotspot['" + name + "'].height", 'prop')
      let ath = 360 / (2000 / (parseFloat(hotspot.locationX))) - 180
      let atv = 180 / ((2000 / (this.scene.sizeWith / this.scene.sizeHeight)) / (parseFloat(hotspot.locationY))) - 90
      this.panoview.krpano().set("hotspot['" + name + "'].ath", ath)
      this.panoview.krpano().set("hotspot['" + name + "'].atv", atv)
      this.panoview.krpano().set("hotspot['" + name + "'].alpha", hotspot.alpha)
      this.panoview.krpano().set("hotspot['" + name + "'].zorder", hotspot.zorder)
      this.panoview.krpano().set("hotspot['" + name + "'].dragging", true)
      this.panoview.krpano().set("hotspot['" + name + "'].distorted", true)
      this.panoview.krpano().set("hotspot['" + name + "'].capture", false)
      this.panoview.krpano().set("hotspot['" + name + "'].mipmapping", true)

      this.panoview.krpano().set("hotspot['" + name + "'].onloaded", () => {
        if (hotspot.image && hotspot.image.imageUrl) {
          let imageWidth = hotspot.iconWidth ? hotspot.iconWidth : 200
          this.panoview.krpano().set("hotspot['" + name + "'].url", this.imageUrl + hotspot.image.imageUrl)
          this.panoview.krpano().set("hotspot['" + name + "'].width", imageWidth)
        } else {
          let imageWidth = hotspot.iconWidth ? hotspot.iconWidth : 80
          this.panoview.krpano().set("hotspot['" + name + "'].url", this.imageUrl + hotspot.icon.iconUrl)
          this.panoview.krpano().set("hotspot['" + name + "'].width", imageWidth)
        }
        if (hotspot.rotation !== null) {
          this.panoview.krpano().set("hotspot['" + name + "'].rx", hotspot.rotation.rx + 180)
          this.panoview.krpano().set("hotspot['" + name + "'].ry", hotspot.rotation.ry + 180)
          this.panoview.krpano().set("hotspot['" + name + "'].rz", hotspot.rotation.rz + 180)
        }
      })

      this.panoview.krpano().set("hotspot['" + name + "'].onclick", () => {
        this.handleClickHotspot(hotspot)
      })

      // check dynamic tooltip
      if (hotspot.dynamic_tooltip && hotspot.dynamic_tooltip.activate) {
        this.panoview.krpano().set("hotspot['" + name + "'].check_center", true)
        this.panoview.krpano().set("hotspot['" + name + "'].check_distance", hotspot.dynamic_tooltip.distance || 10)
        this.panoview.krpano().set("hotspot['" + name + "'].oncenter", () => {
          if (!this.panoview.krpano().get("hotspot['" + name + "'].popup_closed")) {
            this.createHotspotPopup(hotspot)
          }
        })
        this.panoview.krpano().set("hotspot['" + name + "'].outcenter", () => {
          if (!this.panoview.krpano().get("hotspot['" + name + "'].popup_closed")) {
            this.removeHotspotPopup(hotspot)
          }
        })
      }
      // check active view
      if (hotspot.active_view && hotspot.active_view.activate) {
        this.panoview.krpano().set("hotspot['" + name + "'].active_view", hotspot.active_view.distance || 10)
        this.panoview.krpano().set("hotspot['" + name + "'].onactiveview", () => {
          this.handleHotspotOnActiveView(hotspot)
        })
        this.panoview.krpano().set("hotspot['" + name + "'].outactiveview", () => {
          this.handleHotspotOutActiveView(hotspot, hotspot.active_view)
        })
      } else if (this.thumbnailInfo && this.thumbnailInfo.poi_active_view && this.thumbnailInfo.poi_active_view.activate) {
        this.panoview.krpano().set("hotspot['" + name + "'].active_view", this.thumbnailInfo.poi_active_view.distance || 10)
        this.panoview.krpano().set("hotspot['" + name + "'].onactiveview", () => {
          this.handleHotspotOnActiveView(hotspot)
        })
        this.panoview.krpano().set("hotspot['" + name + "'].outactiveview", () => {
          this.handleHotspotOutActiveView(hotspot, this.thumbnailInfo.poi_active_view)
        })
      }

      if (hotspot.enable_title && hotspot.name) {
        this.panoview.krpano().set(`hotspot['${name}'].onhover`, `showtext(${hotspot.name.replace(/[!'(),*]/g, (c) => '%' + c.charCodeAt(0).toString(16))}, STYLE4)`)
      }
      this.panoview.krpano().call("addhotspot('" + name + "')")
      // check active_view and dynamic tooltip at the begining
      this.panoview.krpano().call(`checkhotspot(${name})`)
    },
    showIconHotspot (hotspot) {
      let name = 'hp-' + hotspot.id
      // Set icon default icon is null
      let iconUrl = ''
      if (hotspot.icon === null) {
        iconUrl = window.location.origin + '/static/libraries/hotspot_icon.png'
      } else {
        iconUrl = this.imageUrl + hotspot.icon.iconUrl
      }
      this.panoview.krpano().set("hotspot['" + name + "'].url", iconUrl)
      this.panoview.krpano().set("hotspot['" + name + "'].width", hotspot.iconWidth)
      this.panoview.krpano().set("hotspot['" + name + "'].height", hotspot.iconHeight)

      // convert pixel to krpano ath,atv
      let ath = 360 / (2000 / (parseFloat(hotspot.locationX))) - 180
      let atv = 180 / ((2000 / (this.scene.sizeWith / this.scene.sizeHeight)) / (parseFloat(hotspot.locationY))) - 90
      this.panoview.krpano().set("hotspot['" + name + "'].ath", ath)
      this.panoview.krpano().set("hotspot['" + name + "'].atv", atv)
      this.panoview.krpano().set("hotspot['" + name + "'].alpha", hotspot.alpha)
      this.panoview.krpano().set("hotspot['" + name + "'].zorder", hotspot.zorder)
      this.panoview.krpano().set("hotspot['" + name + "'].capture", false)
      this.panoview.krpano().set("hotspot['" + name + "'].mipmapping", true)
      this.panoview.krpano().set("hotspot['" + name + "'].renderer", 'css3d')

      // event click hotspot
      this.panoview.krpano().set("hotspot['" + name + "'].onclick", () => {
        this.handleClickHotspot(hotspot)
      })
      if (hotspot.dynamic_tooltip && hotspot.dynamic_tooltip.activate) {
        this.panoview.krpano().set("hotspot['" + name + "'].check_center", true)
        this.panoview.krpano().set("hotspot['" + name + "'].check_distance", hotspot.dynamic_tooltip.distance || 10)
        this.panoview.krpano().set("hotspot['" + name + "'].oncenter", () => {
          if (!this.panoview.krpano().get("hotspot['" + name + "'].popup_closed")) {
            this.createHotspotPopup(hotspot)
          }
        })
        this.panoview.krpano().set("hotspot['" + name + "'].outcenter", () => {
          if (!this.panoview.krpano().get("hotspot['" + name + "'].popup_closed")) {
            this.removeHotspotPopup(hotspot)
          }
        })
      }
      // check active view
      if (hotspot.active_view && hotspot.active_view.activate) {
        this.panoview.krpano().set("hotspot['" + name + "'].active_view", hotspot.active_view.distance || 10)
        this.panoview.krpano().set("hotspot['" + name + "'].onactiveview", () => {
          this.handleHotspotOnActiveView(hotspot)
        })
        this.panoview.krpano().set("hotspot['" + name + "'].outactiveview", () => {
          this.handleHotspotOutActiveView(hotspot, hotspot.active_view)
        })
      } else if (this.thumbnailInfo && this.thumbnailInfo.poi_active_view && this.thumbnailInfo.poi_active_view.activate) {
        this.panoview.krpano().set("hotspot['" + name + "'].active_view", this.thumbnailInfo.poi_active_view.distance || 10)
        this.panoview.krpano().set("hotspot['" + name + "'].onactiveview", () => {
          this.handleHotspotOnActiveView(hotspot)
        })
        this.panoview.krpano().set("hotspot['" + name + "'].outactiveview", () => {
          this.handleHotspotOutActiveView(hotspot, this.thumbnailInfo.poi_active_view)
        })
      }

      if (hotspot.enable_title && hotspot.name) {
        this.panoview.krpano().set(`hotspot['${name}'].onhover`, `showtext(${hotspot.name.replace(/[!'(),*]/g, (c) => '%' + c.charCodeAt(0).toString(16))}, STYLE4)`)
      }
      this.panoview.krpano().call("addhotspot('" + name + "')")

      // check active_view and dynamic tooltip at the begining
      this.panoview.krpano().call(`checkhotspot(${name})`)
    },
    showHtmlHotspot (hotspot) {
      let name = 'hp-' + hotspot.id
      this.panoview.krpano().set("hotspot['" + name + "'].url", window.location.origin + '/static/transparent.png')

      // convert pixel to krpano ath,atv
      let ath = 360 / (2000 / (parseFloat(hotspot.locationX))) - 180
      let atv = 180 / ((2000 / (this.scene.sizeWith / this.scene.sizeHeight)) / (parseFloat(hotspot.locationY))) - 90
      this.panoview.krpano().set("hotspot['" + name + "'].width", 5)
      this.panoview.krpano().set("hotspot['" + name + "'].height", 5)
      this.panoview.krpano().set("hotspot['" + name + "'].ath", ath)
      this.panoview.krpano().set("hotspot['" + name + "'].atv", atv)
      this.panoview.krpano().set("hotspot['" + name + "'].zorder", hotspot.zorder)
      this.panoview.krpano().set("hotspot['" + name + "'].renderer", 'css3d')
      this.panoview.krpano().set("hotspot['" + name + "'].scale", 1)

      this.panoview.krpano().set("hotspot['" + name + "'].onloaded", () => {
        let hs = this.panoview.krpano().get('hotspot[' + name + ']')
        let html = hotspot.info.content ? hotspot.info.content : '<div style="width: 200px; height: 100px; background: #fff; display: flex; justify-content: center; aligns-item: center;">No content</div>'
        hs['sprite'].innerHTML = `<div class="sprite-wrap"><div>${html}</div></div>`
      })

      this.panoview.krpano().set("hotspot['" + name + "'].onclick", () => {
        this.trackClickHotspot(hotspot)
      })

      // check active view
      if (hotspot.active_view && hotspot.active_view.activate) {
        this.panoview.krpano().set("hotspot['" + name + "'].active_view", hotspot.active_view.distance || 10)
        this.panoview.krpano().set("hotspot['" + name + "'].onactiveview", () => {
          this.handleHotspotOnActiveView(hotspot)
        })
        this.panoview.krpano().set("hotspot['" + name + "'].outactiveview", () => {
          this.handleHotspotOutActiveView(hotspot, hotspot.active_view)
        })
      } else if (this.thumbnailInfo && this.thumbnailInfo.poi_active_view && this.thumbnailInfo.poi_active_view.activate) {
        this.panoview.krpano().set("hotspot['" + name + "'].active_view", this.thumbnailInfo.poi_active_view.distance || 10)
        this.panoview.krpano().set("hotspot['" + name + "'].onactiveview", () => {
          this.handleHotspotOnActiveView(hotspot)
        })
        this.panoview.krpano().set("hotspot['" + name + "'].outactiveview", () => {
          this.handleHotspotOutActiveView(hotspot, this.thumbnailInfo.poi_active_view)
        })
      }

      this.panoview.krpano().call("addhotspot('" + name + "')")

      // check active_view and dynamic tooltip at the begining
      this.panoview.krpano().call(`checkhotspot(${name})`)
    },
    handleHotspotOnActiveView (hotspot) {
      let name = `hp-${hotspot.id}`
      this.panoview.krpano().call(`tween(hotspot[${name}].scale, 1, 0.3, default)`)
      this.panoview.krpano().call(`tween(hotspot[${name}].alpha, ${hotspot.alpha || 1}, 0.3, default)`)
    },
    handleHotspotOutActiveView (hotspot, settings) {
      let name = `hp-${hotspot.id}`
      if (settings.restricted_type === 'reduce') {
        this.panoview.krpano().call(`tween(hotspot[${name}].scale, ${settings.reduced_size}, 0.3, default)`)
        this.panoview.krpano().call(`tween(hotspot[${name}].alpha, ${settings.reduced_opacity}, 0.3, default)`)
      } else {
        this.panoview.krpano().call(`tween(hotspot[${name}].alpha, 0, 0.5, default)`)
      }
    },
    handleClickHotspot (hotspot, type = 'native') {
      // avoid action for remote view mode
      if (this.disableControl && type === 'native') return

      // send action on remote view mode
      if (!this.onRemoteView) {
        this.sendSocketMessage({
          type: 'view_action',
          data: {action: 'click_hotspot', hotspot}
        })
      }

      // handle hotspot view settings
      let timeOut = 0
      if (hotspot.view) {
        timeOut = 2000
        this.focusView(hotspot.view)
        setTimeout(() => {
          if (this.onHotspotView) {
            this.exitHotspotView(hotspot)
          }
        }, 5000)
      }
      setTimeout(() => {
        if (
          Array.isArray(this.project.feature_toggles) &&
          this.project.feature_toggles.includes('ecommerce') &&
          hotspot.product_id
        ) {
          this.hotspotCurrent = hotspot
          this.showProductDialog = true
        } else if (['point', 'pip'].includes(hotspot.type)) {
          this.onHotspotView = true
          if (hotspot.point !== null) {
            for (let y = 0; y < this.scenes.length; y++) {
              if (this.scenes[y].id === hotspot.point.target_scene_id) {
                this.loading = true
                let _vars = []
                let sceneUrl = this.imageUrl + ((this.scenes[y].sceneOptimize && this.scenes[y].pano_type !== 'multi') ? this.scenes[y].sceneOptimize : this.scenes[y].sceneUri)
                let sceneXml = this.scenes[y].xml ? this.scenes[y].xml.replace(/url="/g, 'url="' + this.imageUrl + this.scenes[y].sceneUri + '/') : null

                let viewObject = {}
                if ((typeof (this.scene.view_settings || {}).north_hlookat) === 'number' && (typeof (this.scenes[y].view_settings || {}).north_hlookat) === 'number') {
                  /**
                   * caculate view direction base on hotspot position
                   * we can caculate the direction when both current pano and target pano has set orientation
                   * */
                  let hotspotAth = this.panoview.krpano().get(`hotspot[hp-${hotspot.id}].ath`)
                  let distanceOrientation = Math.abs(hotspotAth - this.scene.view_settings.north_hlookat)
                  let hlookat = hotspotAth > this.scene.view_settings.north_hlookat ? this.scenes[y].view_settings.north_hlookat + distanceOrientation : this.scenes[y].view_settings.north_hlookat - distanceOrientation
                  viewObject['hlookat'] = hlookat
                } else if (this.scenes[y].initial_view && this.scenes[y].initial_view instanceof Object) {
                  /** set initial_view */
                  Object.assign(viewObject, this.scenes[y].initial_view)
                }

                // set current scene
                this.scene = this.scenes[y]

                if (this.scene.view_settings) {
                  Object.assign(viewObject, {
                    fovmin: this.scene.view_settings.fovmin,
                    fovmax: this.scene.view_settings.fovmax,
                    distortion: this.scene.view_settings.distortion,
                    distortionfovlink: this.scene.view_settings.distortionfovlink
                  })
                }

                this.runCheckLoadPanoProgress()
                this.panoview.loadScene(sceneUrl, _vars, sceneXml, hotspot.point.blend_mode || this.scenes[y].blend_mode, viewObject)
              }
            }
          }
          this.trackClickHotspot(hotspot)
        } else {
          this.onHotspotView = false
          this.hotspotCurrent = hotspot
          this.dialogHotspot = true
          this.trackClickHotspot(hotspot)
        }
      }, timeOut)
    },
    trackClickHotspot (hotspot) {
      let poiType = 'info'
      if (hotspot.type === 'point') {
        poiType = 'nav'
      } else if (hotspot.type === 'image') {
        poiType = 'picture'
      } else if (hotspot.type === 'patch') {
        poiType = hotspot.nadir_patch_position ? 'zenith' : 'nadir'
      } else if (hotspot.type === 'html') {
        poiType = 'sprite'
      } else {
        poiType = hotspot.type
      }
      window.analytics.track('p-vtPoiOpen',
        {
          userid: (this.visitor || {}).id || (this.onlineVisitor || {}).id,
          vtid: this.project.id,
          vturl: window.location.href,
          vttitle: this.project.name,
          pano: this.scenes.findIndex((i) => i.id === this.scene.id) + 1,
          poiid: hotspot.id,
          poiname: (hotspot.metadata || {}).tracking_name,
          poitype: poiType
        }
      )
    },
    exitHotspotView (hotspot) {
      this.focusView({
        vlookat: this.panoview.krpano().get(`hotspot[hp-${hotspot.id}].atv`),
        hlookat: this.panoview.krpano().get(`hotspot[hp-${hotspot.id}].ath`),
        fov: 90
      })
    },
    fetchProjects () {
      this.loading = true
      axios.get(
        `project-sphere/${this.$route.params.username}/${this.$route.params.slug}`,
        {
          params: {
            token: this.projectToken,
            saler_token: this.salerToken
          }
        }
      ).then(response => {
        this.loading = false
        switch (response.status) {
          case 1:
            if (response.data !== null && response.data.scenes.length) {
              this.project = response.data
              this.scenes = response.data.scenes
              this.scene = response.data.scenes[0]
              if (this.$route.query.pano_id && this.$route.query.pano_id !== this.scene.id) {
                let scene = this.scenes.find((item) => item.id === parseInt(this.$route.query.pano_id))
                if (scene) this.scene = scene
              }
              this.parsePlugin(response.data.plugin_installed)
              if (response.data.category_id && response.data.category_id && response.data.category_id !== undefined && response.data.category) {
                this.parseAdditionalFields(response.data.category.fields, JSON.parse(response.data.category_fields))
              }
              if (this.splashEnable &&
                Object.keys(this.splashInfo).length &&
                (!this.privateEnable || (this.privateEnable && this.splashInfo.display_by_login_popup === 'after'))
              ) {
                this.showSplash()
              }
              this.mapOptions.marker.position.lat = parseFloat(response.data.location_lat)
              this.mapOptions.marker.position.lng = parseFloat(response.data.location_lng)
              this.init()

              this.triggerUpdateProfile()

              // init ecommerce feature
              // if (this.privateEnable && response.data.feature_toggles.includes('ecommerce')) {
              //   this.initWebsocket()
              //   if (this.salerToken && this.saler) {
              //     this.fetchVisitors()
              //   }
              // }
            } else {
              this.notFound = true
            }
            if (this.privateEnable && this.projectToken) {
              window.analytics.track('p-vtPrivateHomePanoAccessLogin',
                {
                  vtid: response.data.id,
                  vturl: window.location.href,
                  vttitle: response.data.name,
                  pano: 1
                }
              )
            } else {
              window.analytics.track('p-vtHomePanoAccess',
                {
                  vtid: response.data.id,
                  vturl: window.location.href,
                  vttitle: response.data.name,
                  pano: 1
                }
              )
            }
            this.checkUrlToOpenZoom()
            break
          case 0:
            this.message422(response.errors.message)
            break
          case 403:
            if (this.messageWarning) {
              this.$notify({
                type: 'warning',
                message: this.messageWarning
              })
            }
            this.showAuthenticationDialog(response.data)
            this.clearPrivateTourStorage()
            break
          case 503:
            if (response.data.type === 'direct' && response.data.project_slug && response.data.username) {
              window.location.href = `${window.location.origin}/tour/${response.data.username}/${response.data.project_slug}`
            } else {
              this.project = response.data
              this.maintenanceMode = true
            }
            break
          case 404:
            this.notFound = true
            break
          default:
            this.messageError()
            break
        }
      })
    },
    clearPrivateTourStorage () {
      this.projectToken = null
      this.salerToken = null
      this.visitorId = null
      this.salerId = null
      this.saler = null
      this.visitor = null
      ls.remove('projectToken')
      ls.remove('salerToken')
      ls.remove('visitorId')
      ls.remove('salerId')
      ls.remove('saler')
      ls.remove('visitor')
    },
    showAuthenticationDialog (data) {
      this.forbiddenProject = true
      this.basicProjectInfo = data
      if (data.agency_id) {
        this.profileInfo.id = data.agency_id
        this.fetchAgency()
      }
      if (data.splash_popup) {
        this.splashInfo = data.splash_popup
        this.showSplash()
      } else {
        this.showLoginPopup = true
      }
    },
    showSplash () {
      setTimeout(() => {
        this.showSplashPopup = true
        if (this.splashInfo.auto_close && this.splashInfo.auto_close_time) {
          setTimeout(() => {
            this.continueFollowSplash()
          }, this.splashInfo.auto_close_time * 1000)
        }
      }, 500)
    },
    continueFollowSplash () {
      this.showSplashPopup = false
      if (this.forbiddenProject) {
        this.showLoginPopup = true
      }
    },
    parseAdditionalFields (fields, categoryFields) {
      forEach(fields, field => {
        let index = findIndex(categoryFields, ['field_id', field.id.toString()])
        this.additionalFields[field.label] = null
        if (index !== -1) {
          this.additionalFields[field.label] = categoryFields[index].value
        }
      })
    },
    parsePlugin (plugins) {
      forEach(plugins, plugin => {
        if (plugin.plugin.slug === 'gallery' && plugin.config) {
          this.galleryEnable = true
          if (plugin.config['images-array']) {
            this.galleryContent = plugin.config['images-array']
            forEach(this.galleryContent, image => {
              image.type = 'portrait'
            })
          }
        }
        if (plugin.plugin.slug === 'agencies' && plugin.config !== null && plugin.config !== 'null') {
          this.profileEnable = true
          this.profileInfo.id = plugin.config['agency_id']
          this.fetchAgency()
        }
        if (plugin.plugin.slug === 'autorotation') {
          this.rotationEnable = true
          if (plugin.plugin.slug === 'autorotation' && plugin.config !== null && plugin.config !== 'null') {
            this.rotationInfo = plugin.config
          }
        }
        if (plugin.plugin.slug === 'private-tour' && plugin.config) {
          this.privateEnable = true
        }
        if (plugin.plugin.slug === 'thumbnail' && plugin.config) {
          this.thumbnailEnable = true
          this.thumbnailInfo = plugin.config
        }
        if (plugin.plugin.slug === 'splash-popup' && plugin.config) {
          this.splashEnable = true
          this.splashInfo = plugin.config
        }
      })
    },
    fetchAgency () {
      axios.get('agency/' + this.profileInfo.id).then(res => {
        if (res.status === 1) {
          this.profileInfo = res.data
        } else {
          this.messageError()
        }
      })
    },
    handleClickShareButton () {
      if (navigator.share) {
        navigator.share({
          url: this.viewUrl
        }).then(() => {
        }).catch(console.error)
      } else {
        this.sharePopover = !this.sharePopover
      }
    },
    openBoxShare (url) {
      const trackKey = url.includes('facebook') ? 'FB' : 'Twitter'
      window.analytics.track(`p-vtEditPublishShare${trackKey}`,
        {
          vturl: window.location.href,
          vtid: this.project.id,
          vttitle: this.project.name
        }
      )
      this.popup.window = window.open(
        url,
        'sharer',
        'status=' + (this.popup.status ? 'yes' : 'no') +
        ',height=' + this.popup.height +
        ',width=' + this.popup.width +
        ',resizable=' + (this.popup.resizable ? 'yes' : 'no') +
        ',left=' + this.popup.left +
        ',top=' + this.popup.top +
        ',screenX=' + this.popup.left +
        ',screenY=' + this.popup.top +
        ',toolbar=' + (this.popup.toolbar ? 'yes' : 'no') +
        ',menubar=' + (this.popup.menubar ? 'yes' : 'no') +
        ',scrollbars=' + (this.popup.scrollbars ? 'yes' : 'no') +
        ',location=' + (this.popup.location ? 'yes' : 'no') +
        ',directories=' + (this.popup.directories ? 'yes' : 'no')
      )
      this.popup.window.focus()
    },
    handleClickThumbnail (scene) {
      if (!this.disableControl) {
        this.sendSocketMessage({ type: 'view_action', data: { action: 'click_thumbnail', scene } })
        this.clickThumbnail(scene)
      }
    },
    clickThumbnail (scene) {
      clearTimeout(this.autoNextScene)
      if (this.enabledAutoRotate) {
        let rotationSpeed = this.rotationEnable ? this.rotationInfo.speed : 3
        this.autoNextScene = setTimeout(() => {
          this.nextScene()
        }, 360000 / rotationSpeed)
      }
      this.changeScene(scene)
    },
    changeScene (scene) {
      if (scene.id !== this.scene.id) {
        this.scenes[this.indexSceneCurrent].initial_view = {
          hlookat: this.panoview.krpano().get('view.hlookat'),
          vlookat: this.panoview.krpano().get('view.vlookat'),
          fov: this.panoview.krpano().get('view.fov')
        }
        this.indexSceneCurrent = findIndex(this.scenes, ['id', scene.id])
        this.scene = scene
        let _vars = []

        let viewObject = {}
        if (this.scene.initial_view instanceof Object) {
          Object.assign(viewObject, this.scene.initial_view)
        }
        if (this.scene.view_settings) {
          Object.assign(viewObject, {
            fovmin: this.scene.view_settings.fovmin,
            fovmax: this.scene.view_settings.fovmax,
            distortion: this.scene.view_settings.distortion,
            distortionfovlink: this.scene.view_settings.distortionfovlink
          })
        }

        if (scene.pano_type === 'video') {
          this.panoview.loadVideo(this.videoUrl + this.scene.sceneUri, '', _vars, this.scene.blend_mode, viewObject)
        } else {
          let sceneUrl = this.imageUrl + ((this.scene.sceneOptimize && this.scene.pano_type !== 'multi') ? this.scene.sceneOptimize : this.scene.sceneUri)
          let sceneXml = this.scene.xml ? this.scene.xml.replace(/url="/g, 'url="' + this.imageUrl + this.scene.sceneUri + '/') : null
          this.runCheckLoadPanoProgress()
          this.panoview.loadScene(sceneUrl, _vars, sceneXml, this.scene.blend_mode, viewObject)
        }
        this.upViewCount(scene.id)
        if (this.privateEnable && this.projectToken) {
          window.analytics.track('p-vtPrivatePanoAccess',
            {
              userid: 'visitor',
              vtid: this.project.id,
              vturl: window.location.href,
              vttitle: this.project.name,
              panotitle: scene.name,
              pano: this.indexSceneCurrent + 1
            }
          )
        } else {
          window.analytics.track('p-vtPanoAccess',
            {
              userid: 'visitor',
              vtid: this.project.id,
              vturl: window.location.href,
              vttitle: this.project.name,
              panotitle: scene.name,
              pano: this.indexSceneCurrent + 1
            }
          )
        }
      }
    },
    upViewCount (sceneId) {
      axios.post('view-scene/' + sceneId)
    },
    openGallery () {
      this.showGallery = true
    },
    openMap () {
      this.showMap = true
    },
    openInfo () {
      this.showInfo = true
    },
    openProfile () {
      this.showProfile = true
    },
    openPanoInfo () {
      this.showPanoInfo = true
    },
    nextScene () {
      clearTimeout(this.autoNextScene)
      if (!this.loading) {
        if (this.indexSceneCurrent < this.scenes.length - 1) {
          if (this.enabledAutoRotate) {
            let rotationSpeed = this.rotationEnable ? this.rotationInfo.speed : 3
            this.autoNextScene = setTimeout(() => {
              this.nextScene()
            }, 360000 / rotationSpeed)
          }
          this.changeScene(this.scenes[this.indexSceneCurrent + 1])
        }
      }
    },
    preScene () {
      if (!this.loading) {
        if (this.indexSceneCurrent > 0) {
          this.changeScene(this.scenes[this.indexSceneCurrent - 1])
        }
      }
    },
    autoRotate () {
      clearTimeout(this.autoNextScene)
      if (this.enabledAutoRotate) {
        this.enabledAutoRotate = false
        this.panoview.krpano().set('autorotate.enabled', false)
      } else {
        this.enabledAutoRotate = true
        this.panoview.krpano().set('autorotate.enabled', true)
        this.panoview.krpano().set('autorotate.waittime', '0.5')
        let rotationSpeed = this.rotationEnable ? this.rotationInfo.speed : 3
        this.panoview.krpano().set('autorotate.speed', rotationSpeed)
        this.autoNextScene = setTimeout(() => {
          this.nextScene()
        }, 360000 / rotationSpeed)
      }
    },
    handleOnclickPano () {
      if (this.enabledAutoRotate) {
        this.enabledAutoRotate = false
        this.panoview.krpano().set('autorotate.enabled', false)
        clearTimeout(this.autoNextScene)
      }
    },
    checkSizeTypePicture (event) {
      if (event.target.clientHeight > event.target.clientWidth) {
        event.target.className = 'portrait-picture'
      } else {
        event.target.className = 'landscape-picture'
      }
    },
    submitLoginForm () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          let loginUrlRoute = this.basicProjectInfo.config.login_without_password ? 'login-without-password' : 'login'
          axios.post(
            `project/${this.basicProjectInfo.id}/visitors/${loginUrlRoute}`,
            Object.assign(
              { theme: this.basicProjectInfo.theme ? this.basicProjectInfo.theme.slug : undefined },
              this.loginForm
            )
          ).then(res => {
            switch (res.code) {
              case 200:
                if (!res.data.token && res.data.login_verify) {
                  this.visitor = res.data
                  this.visitor.id = res.data.visitor_id
                  this.visitorId = res.data.visitor_id
                  this.showVerifyVisitorEmail()
                  // identify and track event
                  window.analytics.identify(res.data.visitor_id, {
                    email: this.loginForm.email.toLowerCase(),
                    role: 'visitor',
                    wipo: this.basicProjectInfo.theme && this.basicProjectInfo.theme.slug === 'wipo-main',
                    lang: this.$i18n.locale
                  })
                } else {
                  this.forbiddenProject = false
                  this.projectToken = res.data.token
                  this.visitorId = res.data.id
                  this.visitor = res.data
                  ls.set('projectToken', res.data.token)
                  ls.set('visitorId', res.data.id)
                  ls.set('visitor', res.data)
                  window.analytics.identify(res.data.id, {
                    email: this.loginForm.email.toLowerCase(),
                    role: 'visitor',
                    wipo: this.basicProjectInfo.theme && this.basicProjectInfo.theme.slug === 'wipo-main',
                    lang: this.$i18n.locale
                  }, {}, () => {
                    window.analytics.track('p-vtPrivateAccessLogin',
                      {
                        vtid: this.project.id,
                        vttitle: this.basicProjectInfo.name,
                        vturl: window.location.href,
                        vtprivateVisitorLogin: this.loginForm.email
                      }
                    )
                  })
                  this.messageWarning = this.$t('This user is not autorised yet')
                  this.fetchProjects()

                  if (res.data.theme === 'wipo-main' && !res.data.first_name) {
                    this.showVisitorProfileForm = true
                  }
                }
                break
              case 422:
                this.message422(res.data.errors)
                break
              case 404:
                // Fix this because message is "W"
                this.$message({
                  type: 'warning',
                  message: this.$t('Account seem does not exist')
                })
                break
              default:
                this.messageError()
                break
            }
          })
        }
      })
    },
    submitSalerForm () {
      if (this.$refs.loginForm.validate()) {
        axios.post(`project/${this.basicProjectInfo.id}/sale-associates/login`, this.loginForm).then(res => {
          switch (res.code) {
            case 200:
              this.forbiddenProject = false
              this.salerToken = res.data.token
              this.salerId = res.data.id
              this.saler = res.data
              ls.set('salerToken', res.data.token)
              ls.set('salerId', res.data.id)
              ls.set('saler', res.data)
              this.messageWarning = this.$t('This user is not autorised yet')
              this.fetchProjects()
              // Track event
              window.analytics.identify(this.loginForm.email, {
                email: this.loginForm.email,
                role: 'visitor',
                lang: this.$i18n.locale
              })
              setTimeout(() => {
                window.analytics.track('p-vtPrivateAccessSALogin',
                  {
                    vtid: this.project.id,
                    vttitle: this.project.name,
                    vturl: window.location.href,
                    vtprivateVisitorLogin: this.loginForm.email
                  }
                )
              }, 1000)
              break
            case 422:
              this.message422(res.data.errors)
              break
            case 404:
              // Fix this because message is "W"
              this.$message({
                type: 'warning',
                message: this.$t('Wrong Email or Password')
              })
              break
            default:
              this.messageError()
              break
          }
        })
      }
    },
    showVerifyVisitorEmail () {
      this.showLoginPopup = false
      this.showVerifyPopup = true
      setTimeout(() => {
        if (this.$refs.verifyVisitorFormFirstInput) {
          this.$refs.verifyVisitorFormFirstInput.focus()
        }
      }, 300)
    },
    sendVerifyVisitorForm () {
      this.$refs.verifyVisitorForm.validate((valid) => {
        if (valid) {
          this.verifyVisitorFormLoading = true
          let formData = Object.assign(
            this.verifyVisitorForm,
            {
              visitor_id: this.visitor.id,
              theme: this.basicProjectInfo.theme.slug
            }
          )
          axios.post(
            'project/visitors/login-verify',
            formData
          ).then((res) => {
            this.verifyVisitorFormLoading = false
            switch (res.code) {
              case 200:
                this.forbiddenProject = false
                this.projectToken = res.data.token
                this.visitor.token = res.data.token
                this.visitor.email = res.data.email
                ls.set('projectToken', res.data.token)
                ls.set('visitorId', this.visitorId)
                ls.set('visitor', this.visitor)
                window.analytics.track('p-vtPrivateHomePanoAccessWipoLoginCodeConfirmation',
                  {
                    vtid: this.basicProjectInfo.id,
                    vttitle: this.basicProjectInfo.name,
                    vturl: window.location.href,
                    vtprivateVisitorLogin: this.loginForm.email,
                    pano: 1
                  }, {}, () => {
                    window.analytics.track('p-vtPrivateAccessLogin',
                      {
                        vtid: this.project.id,
                        vttitle: this.project.name,
                        vturl: window.location.href,
                        vtprivateVisitorLogin: this.visitor.email
                      }
                    )
                  }
                )
                this.messageWarning = this.$t('This user is not autorised yet')
                this.fetchProjects()
                this.showVerifyPopup = false
                this.showVisitorProfileForm = true
                setTimeout(() => {
                  this.$refs.visitorProfileFormFirstInput.focus()
                }, 300)
                break
              case 422:
                let errors = res.data.errors[Object.keys(res.data.errors)]
                this.$message({
                  type: 'error',
                  message: Array.isArray(errors) ? errors[0] : errors
                })
                break
              case 404:
                // Fix this because message is "W"
                this.$message({
                  type: 'warning',
                  message: this.$t('Account seem does not exist')
                })
                break
              default:
                this.messageError()
                break
            }
          })
        }
      })
    },
    submitVisitorProfile () {
      this.$refs.visitorProfileForm.validate((valid) => {
        if (valid) {
          this.visitorProfileFormLoading = true
          let formData = Object.assign(
            {},
            this.visitorProfileForm,
            {visitor_id: this.visitor.id, theme: this.project.theme.slug, role: this.visitorProfileForm.role.join(', ')}
          )
          axios.post(
            'project/visitors/change-profile',
            formData
          ).then((res) => {
            this.visitorProfileFormLoading = false
            switch (res.code) {
              case 200:
                this.showVisitorProfileForm = false
                window.analytics.identify(this.visitor.id, this.visitorProfileForm)
                window.analytics.track('p-vtPrivateHomePanoAcessWipoRegistration',
                  {
                    vtid: this.project.id,
                    vttitle: this.project.name,
                    vturl: window.location.href,
                    vtprivateVisitorLogin: this.visitor.email,
                    pano: 1
                  }
                )
                this.visitor = {...this.visitor, ...res.data}
                ls.set('visitor', this.visitor)
                break
              case 422:
                let errors = res.data.errors[Object.keys(res.data.errors)]
                this.$message({
                  type: 'error',
                  message: Array.isArray(errors) ? errors[0] : errors
                })
                break
              case 404:
                // Fix this because message is "W"
                this.$message({
                  type: 'warning',
                  message: this.$t('Account seem does not exist')
                })
                break
              default:
                this.messageError()
                break
            }
          })
        }
      })
    },
    sendRequestDemand () {
      if (this.$refs.requestForm.validate()) {
        const anonymousId = window.analytics.user().anonymousId()
        const lastestSend = ls.get('lastestSendRequestDemand')
        const totalSend = ls.get('totalSendRequestDemand')
        if (!lastestSend || (lastestSend && new Date().getTime() - lastestSend > 180000 && totalSend < 5)) {
          window.analytics.identify(this.basicProjectInfo.user_id)
          setTimeout(() => {
            window.analytics.track('p-vtPrivateAccessRequest',
              {
                vtid: this.basicProjectInfo.id,
                vttitle: this.basicProjectInfo.name,
                vturl: window.location.href,
                vtprivateAODname: this.requestForm.name,
                vtprivateAODphone: this.requestForm.phone,
                vtprivateAODemail: this.requestForm.email,
                vtprivateAODpassword: this.requestForm.password,
                username: this.$route.params.username,
                recipient: this.basicProjectInfo.config.request_contact.email,
                authoremail: this.basicProjectInfo.config.request_contact.email,
                authorphone: this.basicProjectInfo.config.request_contact.phone
              }
            )
            this.$notify({
              type: 'success',
              message: this.$t('Submitted successfully')
            })
            ls.set('lastestSendRequestDemand', new Date().getTime())
            if (totalSend) {
              ls.set('totalSendRequestDemand', parseInt(totalSend) + 1)
            } else {
              ls.set('totalSendRequestDemand', 1)
            }
            window.analytics.setAnonymousId(anonymousId)
          }, 300)
        } else {
          this.$notify({
            type: 'error',
            message: this.$t('You sent too many requests, the author is already aware about your demand.')
          })
        }
      }
    },
    openEmailto (email) {
      window.location.href = `mailto:${email}`
    },
    trackShareEmail () {
      window.analytics.track('p-vtEditPublishShareMail',
        {
          vturl: window.location.href,
          vtid: this.project.id,
          vttitle: this.project.name
        }
      )
    },
    toggleThumbnail () {
      let toggleBtn = document.getElementsByClassName('toggle-thumbnail-btn')[0]
      toggleBtn.classList.remove('toggle-thumbnail-animation-up')
      toggleBtn.classList.remove('toggle-thumbnail-animation-down')
      if (this.thumbnailInfo.show_thumbnail_on_start) {
        toggleBtn.classList.add('toggle-thumbnail-animation-down')
      } else {
        toggleBtn.classList.add('toggle-thumbnail-animation-up')
      }
      this.thumbnailInfo.show_thumbnail_on_start = !this.thumbnailInfo.show_thumbnail_on_start
    },
    createHotspotPopup (hotspot) {
      let popupName = `hp-${hotspot.id}-popup`
      let popupContent = hotspot.dynamic_tooltip.content
      let popupWidth = hotspot.dynamic_tooltip.width || 200
      let popupDistance = Math.min(hotspot.iconWidth / 2, 50) + (Number.isInteger(hotspot.dynamic_tooltip.margin) ? hotspot.dynamic_tooltip.margin : 0)
      let popupBackgroundColor = hotspot.dynamic_tooltip.background_color
      let popupBorderColor = hotspot.dynamic_tooltip.border_color
      let popupPosition = hotspot.dynamic_tooltip.position || 'right'

      let hotspotAth = this.panoview.krpano().get(`hotspot['hp-${hotspot.id}'].ath`)
      let hotspotAtv = this.panoview.krpano().get(`hotspot['hp-${hotspot.id}'].atv`)
      let hotspotScreen = this.panoview.krpano().spheretoscreen(hotspotAth, hotspotAtv)
      let popupSphere = null

      switch (popupPosition) {
        case 'right':
          popupSphere = this.panoview.krpano().screentosphere(hotspotScreen.x + parseFloat(popupDistance), hotspotScreen.y)
          break
        case 'left':
          popupSphere = this.panoview.krpano().screentosphere(hotspotScreen.x - parseFloat(popupDistance), hotspotScreen.y)
          break
        case 'top':
          popupSphere = this.panoview.krpano().screentosphere(hotspotScreen.x, hotspotScreen.y - parseFloat(popupDistance))
          break
        case 'bottom':
          popupSphere = this.panoview.krpano().screentosphere(hotspotScreen.x, hotspotScreen.y + parseFloat(popupDistance))
          break
        default:
          break
      }

      this.panoview.krpano().set("hotspot['" + popupName + "'].url", '/static/transparent.png')
      this.panoview.krpano().set("hotspot['" + popupName + "'].width", 2)
      this.panoview.krpano().set("hotspot['" + popupName + "'].height", 2)
      this.panoview.krpano().set("hotspot['" + popupName + "'].ath", popupSphere.x)
      this.panoview.krpano().set("hotspot['" + popupName + "'].atv", popupSphere.y)
      this.panoview.krpano().set("hotspot['" + popupName + "'].capture", false)
      this.panoview.krpano().set("hotspot['" + popupName + "'].zorder", 100)
      this.panoview.krpano().set("hotspot['" + popupName + "'].renderer", 'css3d')
      this.panoview.krpano().set("hotspot['" + popupName + "'].scale", 2.45)

      this.panoview.krpano().set("hotspot['" + popupName + "'].onloaded", () => {
        let hs = this.panoview.krpano().get('hotspot[' + popupName + ']')
        let html = `<div class="callout-popup ${popupPosition} hotspot-popup_in" style="width: ${popupWidth}px"><div class="callout-content" style="background: ${popupBackgroundColor}; border-color: ${popupBorderColor};">${popupContent}</div></div>`
        hs['sprite'].innerHTML = html
      })
      this.panoview.krpano().set("hotspot['" + popupName + "'].onclick", () => {
        this.handleClickHotspot(hotspot)
      })

      this.panoview.krpano().call("addhotspot('" + popupName + "')")
    },
    removeHotspotPopup (hotspot) {
      let popupName = `hp-${hotspot.id}-popup`
      let popupContent = hotspot.dynamic_tooltip.content
      let popupWidth = hotspot.dynamic_tooltip.width || 200
      let popupBackgroundColor = hotspot.dynamic_tooltip.background_color
      let popupBorderColor = hotspot.dynamic_tooltip.border_color
      let popupPosition = hotspot.dynamic_tooltip.position || 'right'
      let hs = this.panoview.krpano().get('hotspot[' + popupName + ']')
      if (hs) {
        let html = `<div class="callout-popup ${popupPosition} hotspot-popup_out" style="width: ${popupWidth}px"><div class="callout-content" style="background: ${popupBackgroundColor}; border-color: ${popupBorderColor};">${popupContent}</div></div>`
        hs['sprite'].innerHTML = html
        setTimeout(() => {
          this.panoview.krpano().call("removehotspot('hp-" + hotspot.id + "-popup')")
        }, 300)
      }
    },
    handleViewChange () {
      this.showCartTooltip = false
      this.onHotspotView = false
      if (this.scene.pano_type === 'multi') {
        let currentViewLoading = this.panoview.krpano().get('image.loadstate')
        let totalViewLoading = this.panoview.krpano().get('progress.progress')
        if (currentViewLoading !== 3 && totalViewLoading < 1) {
          this.runCheckLoadPanoProgress()
        }
      }
      if (this.syncViewSession && !this.onRemoteView) {
        this.sendSyncView()
      }
    },
    checkProgress () {
      let loadstate = this.panoview.krpano().get('image.loadstate')
      if (loadstate === 3) {
        this.panoLoading = false
        clearInterval(this.checkPanoLoadingProgress)
      }
    },
    runCheckLoadPanoProgress () {
      this.panoLoading = true
      clearInterval(this.checkPanoLoadingProgress)
      this.checkPanoLoadingProgress = setInterval(this.checkProgress, 1000)
    },
    connectOfflineVisitor (visitor) {
      this.$set(visitor, 'connection_status', 'connected')
      this.offlineVisitor = visitor
      this.visitorListSearch = ''
    },
    initWebsocket () {
      if (!this.socket && (this.salerId || this.visitorId) && this.project.id) {
        let userType = this.projectToken ? 'visitor' : 'sa'
        this.socket = new WebSocket(`${process.env.WEBSOCKET_URL}?token=${this.projectToken || this.salerToken}&user_type=${userType}`)
        this.socket.onopen = (event) => {
          if (this.salerId) {
            this.sendSocketMessage({type: 'list_visitor'})
          }
          this.socket.onmessage = (event) => {
            this.handleSocketMessage(JSON.parse(event.data))
          }
          this.socket.onclose = (event) => {
            this.$notify({
              type: 'warning',
              title: this.$t('Your connection closed'),
              message: this.$t('Please login again'),
              duration: 5000
            })
            if (this.$refs.cart) {
              this.$refs.cart.$emit('clearCart')
            }
            setTimeout(() => {
              this.clearPrivateTourStorage()
              location.reload()
            }, 500)
          }
          this.socket.onerror = (event) => {
            this.$notify({
              type: 'warning',
              title: this.$t('Your connection failed'),
              message: this.$t('Try refresh the page to reconnect.'),
              duration: 0
            })
          }
        }
      }
    },
    sendSocketMessage (data) {
      if (this.socket) {
        this.socket.send(JSON.stringify({action: 'sendmessage', data}))
      }
    },
    handleSocketMessage (message) {
      switch (message.type) {
        case 'view_action':
          if (this.syncViewSession) {
            this.handleSocketViewAction(message.data)
          }
          break
        case 'ask_sync_view':
          this.showConfirmConnection(message.data)
          break
        case 'start_sync_view':
          this.syncViewSession = message.data
          let visitor = this.visitorList.find((i) => i.connection_id === message.data.connection_id)
          if (visitor) {
            this.onlineVisitor = cloneDeep(visitor)
            this.$set(visitor, 'connection_status', 'connected')
            this.sendFirstSyncView()
          }
          this.$message({
            type: 'success',
            message: 'Connected'
          })
          break
        case 'stop_sync_view':
          this.handleStopSyncView(message.data.connection_id)
          break
        case 'reject_sync_view':
          this.handleRejectSyncView(message.data)
          break
        case 'visitor_disconnected':
          this.removeVisitorOnline(message.data)
          break
        case 'visitor_connected':
          this.addVisitorOnline(message.data)
          break
        case 'saler_disconnected':
          if (this.syncViewSession) {
            this.handleStopSyncView(message.data.connection_id)
          }
          break
        case 'list_visitor':
          if (message.data && message.data.length) {
            message.data.forEach((object) => {
              this.addVisitorOnline(object)
            })
          }
          break
        case 'toggle_control':
          if (this.connectedSaler) {
            if (message.data) {
              this.disableControl = false
              this.panoview.krpano().set('control.usercontrol', 'all')
            } else {
              this.disableControl = true
              this.panoview.krpano().set('control.usercontrol', 'off')
            }
          }
          break
        default:
          break
      }
    },
    handleRejectSyncView (data) {
      this.$message({
        message: `${data.name} rejected invitation`
      })
      let visitor = this.visitorList.find((i) => i.connection_id === data.connection_id)
      if (visitor) {
        this.$set(visitor, 'connection_status', undefined)
      }
    },
    handleStopSyncView (connectionId) {
      this.syncViewSession = null
      if (this.salerId) {
        this.showCartPopup = false
        this.onlineVisitor = null
        this.visitorControl = true
        let visitor = this.visitorList.find((i) => i.connection_id === connectionId)
        if (visitor) {
          this.$set(visitor, 'connection_status', undefined)
        }
      } else {
        this.panoview.krpano().set('control.usercontrol', 'all')
        this.disableControl = false
      }
      this.$message({
        message: 'Disconnected'
      })
    },
    handleSocketViewAction (data) {
      this.onRemoteView = true
      this.panoview.krpano().set('control.usercontrol', 'off')
      switch (data.action) {
        case 'change_view':
          this.handleSyncView(data.view)
          break
        case 'select_pano':
          this.handleChangeSceneRemote(data.pano_id)
          break
        case 'click_hotspot':
          if (!this.dialogHotspot) {
            this.handleClickHotspot(data.hotspot, 'remote')
          }
          break
        case 'close_hotspot':
          this.dialogHotspot = false
          break
        case 'click_thumbnail':
          this.clickThumbnail(data.scene)
          break
        case 'close_product_popup':
          this.showProductDialog = false
          break
        case 'open_cart':
          this.showVisitorCartPopup = true
          this.$refs.visitorCart.$emit('fetchCart')
          break
        case 'close_cart':
          this.showVisitorCartPopup = false
          break
        case 'order_confirmed':
          this.showVisitorCartPopup = false
          this.$message({
            type: 'success',
            message: this.$t('Your order has been confirmed and will be send to the store and RL Ops team.')
          })
          break
        default:
          break
      }
      clearTimeout(this.onRemoteViewTimeout)
      this.onRemoteViewTimeout = setTimeout(() => {
        if (!this.disableControl) {
          this.panoview.krpano().set('control.usercontrol', 'all')
        }
        this.onRemoteView = false
      }, 1500)
    },
    sendFirstSyncView () {
      this.sendSocketMessage({
        type: 'view_action',
        data: {
          action: 'select_pano',
          pano_id: this.scene.id
        }
      })
      this.sendSyncView()
    },
    handleChangeSceneRemote (sceneId) {
      let scene = this.scenes.find((item) => item.id === sceneId)
      if (scene) {
        this.changeScene(scene)
      }
    },
    sendSyncView: debounce(function () {
      if (this.socket) {
        let view = {
          vlookat: this.panoview.krpano().get('view.vlookat'),
          hlookat: this.panoview.krpano().get('view.hlookat'),
          fov: this.panoview.krpano().get('view.fov')
        }
        this.sendSocketMessage({ type: 'view_action', data: { action: 'change_view', view } })
      }
    }, 20),
    handleSyncView (view) {
      this.panoview.krpano().call(`lookto(${view.hlookat},${view.vlookat},${view.fov},smooth(180,180,90))`)
    },
    addVisitorOnline (object) {
      let visitor = this.visitorList.find((i) => i.id === parseInt(object.id || object.user_id))
      if (visitor) {
        this.$set(visitor, 'connection_id', object.connection_id)
      }
    },
    removeVisitorOnline (object) {
      if (this.syncViewSession && object.connection_id === this.syncViewSession.connection_id) {
        this.handleStopSyncView()
      }
      let visitor = this.visitorList.find((i) => object.connection_id === i.connection_id)
      if (visitor) {
        this.$set(visitor, 'connection_id', undefined)
        this.$set(visitor, 'connection_status', undefined)
      }
    },
    showConfirmConnection (saler) {
      this.connectedSaler = saler
      this.$confirm(this.$t('A Ralph Lauren Sales Associate wants to share his live view, do you agree?'), this.$t('Live view support'), {
        confirmButtonText: this.$t('Yes'),
        cancelButtonText: this.$t('Cancel'),
        type: 'info'
      }).then(() => {
        this.sendSocketMessage({
          type: 'start_sync_view',
          data: saler
        })
      }).catch(() => {
        this.sendSocketMessage({
          type: 'reject_sync_view',
          data: saler
        })
      })
    },
    connectSession (visitor) {
      this.$set(visitor, 'connection_status', 'connecting')
      this.sendSocketMessage({
        type: 'ask_sync_view',
        data: {
          connection_id: visitor.connection_id
        }
      })
    },
    stopSession () {
      if (this.offlineVisitor) {
        let visitor = this.visitorList.find((item) => item.id === this.offlineVisitor.id)
        if (visitor) {
          this.$set(visitor, 'connection_status', undefined)
        }
        this.offlineVisitor = null
        this.showCartPopup = false
      } else {
        this.$confirm(this.$t('Disconnect current live view session?'), 'Warning', {
          confirmButtonText: this.$t('Yes'),
          cancelButtonText: this.$t('Cancel')
        }).then(() => {
          this.sendSocketMessage({
            type: 'stop_sync_view',
            data: this.syncViewSession
          })
          let visitor = this.visitorList.find((item) => item.connection_id === this.syncViewSession.connection_id)
          if (visitor) {
            this.$set(visitor, 'connection_status', undefined)
          }
          this.syncViewSession = null
          this.showCartPopup = false
          this.visitorControl = true
          this.panoview.krpano().set('control.usercontrol', 'all')
        }).catch()
      }
    },
    toggleVisitorControl () {
      this.visitorControl = !this.visitorControl
      this.sendSocketMessage({
        type: 'toggle_control',
        data: {status: this.visitorControl}
      })
    },
    fetchVisitors () {
      this.visitorOnlineLoading = true
      axios.get('salers/visitors', {
        headers: {
          Authorization: 'Bearer ' + this.salerToken
        }
      }).then((response) => {
        this.visitorOnlineLoading = false
        if (response.code === 200) {
          if (response.data.data) {
            this.visitorList = response.data.data
          }
        } else {
          this.clearPrivateTourStorage()
          location.reload()
        }
      })
    },
    toggleSortListVisitor () {
      this.visitorListSort = this.visitorListSort === 1 ? -1 : 1
      this.visitorList.sort((a, b) => {
        if (a.connection_id === b.connection_id) {
          return 0
        } else if (a.connection_id) {
          return this.visitorListSort
        } else {
          return this.visitorListSort === 1 ? -1 : 1
        }
      })
    },
    handleSubmitOrder (order) {
      this.$refs.cart.$emit('addProduct', order)
      this.$message({
        type: 'success',
        showClose: true,
        message: this.$t('number items was added to the cart', {number: order.quantity})
      })
    },
    handleProductFetched (product) {
      if (this.visitor || this.onlineVisitor) {
        window.analytics.track('p-vtPoiEcom',
          {
            userid: (this.visitor || {}).id || this.onlineVisitor.id,
            vtid: this.project.id,
            vturl: window.location.href,
            vttitle: this.project.name,
            pano: this.scenes.findIndex((i) => i.id === this.scene.id) + 1,
            poiid: (this.hotspotCurrent || {}).id,
            AXNumber: product.sku,
            producttitle: product.name_english || product.name
          }
        )
      }
    },
    closeProductPopup () {
      if (!this.disableControl) {
        this.showProductDialog = false
        this.sendSocketMessage({
          type: 'view_action',
          data: {action: 'close_product_popup'}
        })
      }
    },
    toggleCartBox () {
      this.showCartPopup = !this.showCartPopup
      this.showCartTooltip = false
    },
    handleOpenOrderConfirm () {
      if (this.syncViewSession) {
        this.sendSocketMessage({
          type: 'view_action',
          data: {action: 'open_cart'}
        })
      }
    },
    handleCloseOrderConfirm () {
      if (this.syncViewSession) {
        this.sendSocketMessage({
          type: 'view_action',
          data: {action: 'close_cart'}
        })
      }
    },
    handleOrderConfirmed () {
      this.$message({
        type: 'success',
        message: this.$t('Your order has been confirmed and will be send to the store and RL Ops team.')
      })
      if (this.syncViewSession) {
        this.sendSocketMessage({
          type: 'view_action',
          data: {action: 'order_confirmed'}
        })
      }
    },
    fetchVisitorProfile () {
      if (this.projectToken) {
        axios.get('visitors/profile', {
          headers: {
            Authorization: 'Bearer ' + this.projectToken
          }
        }).then((response) => {
          if (response.code === 200) {
            if (response.data) {
              this.visitor = response.data
              ls.set('visitor', response.data)
              this.triggerUpdateProfile()
            }
          } else {
            this.clearPrivateTourStorage()
            location.reload()
          }
        })
      }
    },
    triggerUpdateProfile () {
      if (this.visitor && !this.visitor.first_name &&
          (
            (this.basicProjectInfo.theme && ['wipo-main'].includes(this.basicProjectInfo.theme.slug)) ||
            (this.project.theme && ['wipo-main'].includes(this.project.theme.slug))
          )) {
        this.showVisitorProfileForm = true
      }
    },
    handleVariantSelected (variant) {
      if (this.visitor && !this.syncViewSession) {
        this.sendSocketMessage({
          type: 'open_product',
          data: variant
        })
      }
    },
    handleShowProductContent (data) {
      this.productContent = data
      this.showProductContent = true
    },
    addEventOnclickThemeBtn () {
      let htmlPoiBtns = document.getElementsByClassName('html-poi-btn')
      if (htmlPoiBtns.length) {
        for (let btn of htmlPoiBtns) {
          btn.onclick = () => {
            try {
              let parsedBtnName = btn.getAttribute('name').split(':')
              if (parsedBtnName.length === 2 && parsedBtnName[0] === 'focus_poi') {
                this.handleFocusPoi(parseInt(parsedBtnName[1]))
              } else if (parsedBtnName.length === 3 && parsedBtnName[0] === 'open_zoom') {
                this.meetingForm.meetingNumber = parsedBtnName[1]
                this.meetingForm.password = parsedBtnName[2]
                if (this.meetingForm.name && this.meetingForm.email) {
                  this.createMeeting()
                } else {
                  this.meetingForm.name = (this.visitor || {}).name
                  this.meetingForm.email = (this.visitor || {}).email
                  this.showMeetingForm = true
                  this.$nextTick(() => {
                    this.$refs.meetingForm_name.focus()
                  })
                }
              }
            } catch (e) { console.log(e) }
          }
        }
      }
    },
    handleFocusPoi (poiId) {
      console.log('handleFocusPoi', poiId)
      let poi = this.scene.hotspots.find((item) => item.id === parseInt(poiId))
      if (poi) {
        let hs = this.panoview.krpano().get(`hotspot[hp-${poi.id}]`)
        this.focusView({
          vlookat: hs.atv,
          hlookat: hs.ath,
          fov: 90
        })
      }
    },
    createMeeting () {
      this.$refs.meetingForm.validate((valid) => {
        if (valid && this.meetingForm.name.trim() && this.meetingForm.email.trim()) {
          this.showMeetingForm = false
          this.openZoomBox(`meeting-number=${this.meetingForm.meetingNumber}&name=${this.meetingForm.name}&email=${this.meetingForm.email}&password=${this.meetingForm.password}&role=${this.meetingForm.role}`)
        } else {
          this.showMeetingForm = true
          this.$nextTick(() => {
            this.$refs.meetingForm_name.focus()
          })
        }
      })
    },
    checkUrlToOpenZoom () {
      if (this.$route.query.open_zoom && this.$route.query.meeting_number && this.$route.query.password && this.$route.query.name && this.$route.query.email && this.$route.query.role) {
        this.openZoomBox(`meeting-number=${this.$route.query.meeting_number}&name=${this.$route.query.name}&email=${this.$route.query.email}&password=${this.$route.query.password}&role=${this.$route.query.role}`)
      }
    },
    openZoomBox (params) {
      this.videoCallUrl = `/static/zoomus/meeting.html?api-url=${process.env.API_URI}zoom-signature&${params}`
      this.showVideoCallBox = true
    },
    handleClickOutside () {
      if (window.localStorage.getItem('zoomus_status') === 'joined') {
        this.toggleMiniVideoCall()
      } else {
        this.showVideoCallBox = false
        this.videoCallPipMode = false
      }
    },
    showConfirmCloseVideoCall () {
      if (window.localStorage.getItem('zoomus_status') === 'joined') {
        this.$confirm('Do you want to close this session?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.showVideoCallBox = false
          this.videoCallPipMode = false
        }).catch((e) => {})
      } else {
        this.showVideoCallBox = false
        this.videoCallPipMode = false
      }
    },
    toggleMiniVideoCall () {
      if (window.localStorage.getItem('zoomus_status') === 'joined') {
        this.videoCallPipMode = !this.videoCallPipMode
      } else {
        this.showVideoCallBox = false
      }
    },
    handleMeetingStatus (msg) {
      if (msg.origin === window.location.origin) {
        if (msg.data.key === 'zoomus_status' && msg.data.value) {
          if (['ended', 'left'].includes(msg.data.value)) {
            this.showVideoCallBox = false
            this.videoCallPipMode = false
          }
        }
      }
    }
  },
  created () {
    this.projectToken = ls.get('projectToken')
    this.salerToken = ls.get('salerToken')
    this.salerId = ls.get('salerId')
    this.visitorId = ls.get('visitorId')
    this.visitor = ls.get('visitor')
    this.saler = ls.get('saler')
  },
  mounted () {
    if (this.$route.params.slug !== undefined && this.$route.params.username !== undefined) {
      this.fetchProjects()
    }
    if (this.$route.query.salogin !== undefined) {
      this.loginType = 'saler'
    } else {
      this.loginType = 'visitor'
    }
    // this.fetchVisitorProfile()
    document.addEventListener('onviewchange', this.handleViewChange, false)
    window.addEventListener('message', this.handleMeetingStatus, false)
  },
  watch: {
    dialogHotspot (value) {
      if (!value) {
        if (this.hotspotCurrent.view) {
          this.onHotspotView = false
          this.exitHotspotView(this.hotspotCurrent)
        }
        if (!this.onRemoteView) {
          this.sendSocketMessage({
            type: 'view_action',
            data: {action: 'close_hotspot'}
          })
        }
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('onviewchange', this.handleViewChange, false)
    document.removeEventListener('message', this.handleMeetingStatus, false)
    if (this.socket) {
      this.socket.close()
    }
  }
}
</script>
<style lang="css" scoped>
#pano {
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
}
.pano-loading-progress {
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
}
.project-title {
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 2;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* padding-left: 20px;
  padding-right: 20px; */
  background-image: transparent;
  padding-top: 10px;
  padding-bottom: 10px;
}
.project-title:hover {
  background-image: linear-gradient(#00000082, transparent);
}
.project-title h2 {
  font-weight: 400;
  margin-top: 0px;
  margin-bottom: 0px;
}
.project-title > div {
  flex-grow: 1;
}
.more-info-popover {
  margin-left: 10px;
  font-size: 20px;
  cursor: pointer;
}
.logo {
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
}
.logo_branch {
  height: auto;
}
.logo_branch img {
  height: intrinsic;
}
@media only screen and (max-width: 600px) {
  .logo_branch {
    height: auto;
  }
}
.logo:active,
.logo:focus {
  outline: none;
}
.more-info-popover:active,
.more-info-popover:focus {
  outline: none;
}
.not-found-actions {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-size: cover;
  background-position: center center;
}
.list-button {
  display: flex;
  flex-direction: row;
}
.scene-list {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: calc(100% - 10px);
  z-index: 3;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
.scene-box {
  height: 90px;
  width: 150px;
  margin: 5px 5px 5px 5px;
  border-radius: 3px;
  overflow: hidden;
}
.scene-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.scene-box_inside {
  width: 100%;
  height: 100%;
  color: #fff;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border-radius: 3px;
  position: relative;
}
.scene-box_inside .active-bar {
  position: absolute;
  display: none;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 10px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0px 0px 3px 3px;
}
.scene-box_inside.active .active-bar{
  display: block;
}
/* .scene-box_inside i {
  font-size: 20px;
}
.scene-box_inside p {
  margin-bottom: 0px;
} */
.swiper-button-disabled {
    display: none;
}
.swiper-button-next {
  background-image: none;
  color: #fff;
  height: 28px;
  top: 60%;
  right: -2px;
}
.swiper-button-prev {
  background-image: none;
  color: #fff;
  height: 28px;
  top: 60%;
  left: 2px;
}
.swiper-container {
  height: 100px;
  width: 100%;
}
@media only screen and (max-height: 480px) {
  .swiper-container {
    height: 50px;
    width: 50%;
  }
}
.back-to-home {
  text-decoration: none;
}
.addon-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.addon-btn i {
  font-size: 20px;
}
.navigation-btn svg {
  padding: 5px;
}
.navigation-btn {
  cursor: pointer;
  position: absolute;
  top: 50%;
  margin-top: -45px;
  margin-left: -35px;
  width: 70px;
  z-index: 3;
}
.arrow-left {
  left: 55px;
}
.arrow-right {
  right: 0px;
}
.arrow-left:hover polyline,
.arrow-left:focus polyline {
  stroke-width: 3;
}
.arrow-left:active polyline {
  stroke-width: 6;
  transition: all 100ms ease-in-out;
}
.arrow-right:hover polyline,
.arrow-right:focus polyline {
  stroke-width: 3;
}
.arrow-right:active polyline {
  stroke-width: 6;
  transition: all 100ms ease-in-out;
}
polyline {
  transition: all 250ms ease-in-out;
}
.author-mobile {
  position: absolute;
  top: 55px;
  right: 0px;
  z-index: 1;
  color: #fff;
  padding: 5px 23px 5px 5px;
  background-image: linear-gradient(to right, transparent , #0000006b);
}
.autorotate-button {
  position: absolute;
  right: 15px;
  bottom: 115px;
  z-index: 1;
  cursor: pointer;
}
.bottom-actions {
  z-index: 1;
  cursor: pointer;
  transition: all 5s;
  display: flex;
  position: relative;
  height: 34px;
  transition: all 1s;
}
.bottom-actions .toggle-thumbnail-btn {
  position: absolute;
  top: 16px;
  left: 0;
  right: 0;
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  display: flex;
}
/* .toggle-thumbnail-animation-up {
  animation-name: slideup;
  animation-duration: 0.4s;
} */
.toggle-thumbnail-animation-down {
  animation-name: slidedown;
  animation-duration: 0.4s;
}
.bottom-actions .top-line {
  border-top: 1px solid #fff;
  flex-grow: 1;
}
.bottom-actions .bottom-line {
  border-bottom: 1px solid #fff;
  flex-grow: 1;
}
.bottom-actions i {
  font-size: 24px;
  color: #fff;
  height: 16px;
  outline: none;
}
.bottom-actions .el-icon-caret-bottom {
  display: flex;
  align-items: flex-end;
  height: 15px;
}
.email-share-button {
  width: 100%;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #dc4e41;
  margin-top: 20px;
  color: #fff;
  text-decoration: none;
  border-radius: 3px;
}
.portrait-picture {
  object-fit: cover;
  height: 100%;
}
.landscape-picture {
  object-fit: cover;
  vertical-align: center;
  width: 100%;
}
.active-language {
  color: #2795d3;
}
.action-buttons {
  display: flex;
  justify-content: flex-end;
}
.action-buttons .el-dropdown {
  display: flex;
  justify-content: center;
  align-items: center;
}
.action-buttons .el-button {
  width: 32px;
  height: 32px;
  background: rgba(2, 2, 2, 0.3);
  color: #fff;
}
.action-buttons .el-button:hover {
  border: 1px solid #fff;
  box-shadow: 0px 1px 5px 2px #FFFFFF;
}
.more-info-btn {
  width: 30px;
  height: 30px;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 2, 2, 0.3);
}
#forbiddenScreen {
  width: 100vw;
  height: 100vh;
}
#forbiddenScreen .background {
  width: 100%;
  height: 100%;
  background-image: url('/static/login_background.jpg');
  background-size: cover;
  background-position: center center;
  filter: blur(8px);
  -webkit-filter: blur(8px);
}
#splashPopupWrap {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
}
#splashPopupWrap .background {
  width: 100%;
  height: 100%;
  background-color: #00000014;
  position: fixed;
  border-radius: 5px;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  border: 1px solid #ffffff3b;
}
.splash-popup {
  /* margin-top: 50px; */
  padding: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 5px;
  text-align: center;
  max-height: 80%;
  overflow: auto;
  min-width: 280px;
  max-width: 90vw;
}
.authentication-box {
  padding: 16px;
  position: absolute;
  top: 52%;
  left: 50%;
  min-width: 280px;
  max-height: 88vh;
  /* overflow: auto; */
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 5px;
  text-align: center;
}
/* .authentication-box .profile-box {
  position: relative;
} */
.authentication-box .profile-avatar {
  width: 60px;
  height: 60px;
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translate(-50%, 0%);
  border-radius: 50%;
  background-color: #fff;
  object-fit: cover;
}
.authentication-box .project-name {
  padding-top: 8px;
  margin-bottom: 8px;
  margin-top: 0px;
  color: var(--color-theme);
  position: relative;
}
.authentication-box .project-name > span {
  display: block;
  margin-top: 10px;
}
.authentication-box .author-name {
  margin-top: 0px;
  font-size: 12px;
}
.authentication-box h4 {
  color: var(--color-theme);
  margin-bottom: 0px;
}
.authen-form p {
  margin-top: 0px;
}
.request-form .el-button {
  width: 100%;
}
.online-visitors-box {
  position: absolute;
  top: 60px;
  right: 10px;
  z-index: 5;
}
.visitor-list {
  width: 300px;
  max-width: calc(var(--vw, 1vw) * 90);
  background: rgb(255, 255, 255, 0.8);
  border-radius: 4px;
}
.visitor-list__content {
  width: 100%;
  max-height: 400px;
  overflow: auto;
}
.online-dot {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: red;
}
.online-dot__active {
  background: greenyellow;
}
.live-view-status {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}
.live-view-status .el-button {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: rgba(0, 0, 0, 0.3);
}
.product-popup {
  position: absolute;
  right: 10%;
  top: 50%;
  transform: translate(0px, -50%);
  z-index: 5;
  background: #fff;
  border-radius: 4px;
  max-height: calc(var(--vh, 1vh) * 90);
  width: 380px;
  overflow: auto;
}
@media only screen and (max-width: 768px),
only screen and (max-height: 768px) {
  .product-popup {
    right: initial;
    width: calc(var(--vw, 1vw) * 90);
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .live-view-status {
    position: absolute;
    top: 10px;
    left: 10px;
    transform: none;
  }
}
.cart-box {
  position: absolute;
  top: 50%;
  left: 0px;
  z-index: 6;
  background-color: #fff;
  border-radius: 4px;
  width: 320px;
  min-height: 100px;
  transform: translateY(-50%);
}
.cart-box .close-btn {
  cursor: pointer;
}
.visitor-cart-box {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.text-capitalize {
  text-transform: capitalize;
}
.popup-wrapper {
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5)
}
.popup-wrapper .popup {
  width: 900px;
  height: auto;
  max-width: 90%;
  max-height: 90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  position: absolute;
}
.popup-wrapper .hotspot-box-info {
  overflow: auto;
  height: auto;
  max-height: 85vh;
}
.hotspot-box-info__closed-btn {
  position: absolute;
  top: -24px;
  right: 0px;
}
.hotspot-box-info__closed-btn i {
  color: #fff;
}
.video-call-wrapper {
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.pip-mode {
  width: 30vw;
  height: calc(22.5vw + 28px);
  right: 10px;
  bottom: 80px;
  top: auto;
  left: auto;
}
.video-call-wrapper .control-group {
  width: 900px;
  max-width: 100%;
  height: 28px;
}
.video-call-wrapper .control-group i {
  color: #fff;
  cursor: pointer;
  font-size: 28px;
}
.video-call-wrapper .control-group img {
  cursor: pointer;
}
.video-call-wrapper iframe {
  width: 70vw;
  height: 52.5vw;
  max-width: 90%;
  max-height: 90%;
  border: none;
}
.pip-mode iframe {
  border-radius: 4px;
  height: 22.5vw;
  max-width: 100%;
  max-height: 100%;
}
@media only screen and (min-width: 960px) {
  .pip-mode {
    bottom: 20px;
  }
}
</style>
<style>
.product-content-dialog {
  background: transparent;
}
.product-content-dialog .el-dialog {
  background: transparent;
  border-top: none;
}
.product-content-dialog .el-dialog__body {
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100 - 30px);
  padding: 0px;
}
.more-info-popover {
  margin-left: 10px;
  font-size: 20px;
  cursor: pointer;
}
.more-info-popover__item {
  margin: 8px 0px;
  height: 28px;
  display: flex;
  align-items: center;
}
.more-info-popover__item span {
  font-size: 12px;
  color: #409eff;
}
.lang-btn  {
  width: 100px;
}
.lang-btn .el-input__inner {
  background-color: transparent !important;
  padding-left: 22px !important;
}
.project-info-dialog .el-dialog__header {
  color: #2795D3 !important;
  border-bottom: 1px solid #2795D3 !important;
  min-height: 24px;
}
.project-info-dialog .el-dialog__title {
  color: #2795D3 !important;
}
.project-info-dialog .el-dialog__body {
  max-height: 70vh;
  overflow: auto;
}
.project-info-dialog .el-carousel__arrow {
  width: 40px;
  height: 40px;
  font-size: 38px;
  background-color: rgba(31, 45, 61, 0.25);
}

/* transitions */
.slide-fade-enter-active {
  transition: 0.4s;
}
.slide-fade-leave-active {
  transition: 0.4s;
}
.slide-fade-enter {
  transform: translate(0, 100%);
}
.slide-fade-leave-to {
  transform: translate(0, 100%);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
@keyframes slideup {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-100px);
  }
}
@keyframes slidedown {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(100px);
  }
}
.splash-popup__content,
.authentication-box * {
  max-width: 100%;
}
.authentication-box p {
  overflow: hidden;
}
.hotspot-popup_in {
  animation-name: hotspotPopupIn;
  animation-duration: .5s;
}
.hotspot-popup_out {
  animation-name: hotspotPopupOut;
  animation-duration: .5s;
}
.hotspot-popup_in.left {
  animation-name: hotspotPopupLeftIn;
  animation-duration: .5s;
}
.hotspot-popup_out.left {
  animation-name: hotspotPopupLeftOut;
  animation-duration: .5s;
}
.hotspot-popup_in.top {
  animation-name: hotspotPopupTopIn;
  animation-duration: .5s;
}
.hotspot-popup_out.top {
  animation-name: hotspotPopupTopOut;
  animation-duration: .5s;
}
.hotspot-popup_in.bottom {
  animation-name: hotspotPopupBottomIn;
  animation-duration: .5s;
}
.hotspot-popup_out.bottom {
  animation-name: hotspotPopupBottomOut;
  animation-duration: .5s;
}
.scale-enter-active {
  animation-name: scaleIn;
  animation-duration: .5s;
}
.scale-leave-active {
  animation-name: scaleOut;
  animation-duration: .5s;
}
@keyframes scaleIn {
  from {
    transform: scale(0.3) translateY(-50%);
    transform-origin: top left;
  }

  to {
    transform: scale(1) translateY(-50%);
    transform-origin: right;
  }
}
@keyframes scaleOut {
  from {
    transform: scale(1) translateY(-50%);
    transform-origin: right;
  }

  to {
    transform: scale(0.3) translateY(-50%);
    transform-origin: top left;
  }
}
@keyframes hotspotPopupIn {
  from {
    transform: scale(0.1) translate(0, calc(-50% + 4px));
    transform-origin: top left;
  }

  to {
    transform: scale(1) translate(0, calc(-50% + 4px));
    transform-origin: right;
  }
}
@keyframes hotspotPopupOut {
  from {
    transform: scale(1) translate(0, calc(-50% + 4px));
    transform-origin: right;
  }

  to {
    transform: scale(0.1) translate(0, calc(-50% + 4px));
    transform-origin: top left;
  }
}
@keyframes hotspotPopupLeftIn {
  from {
    transform: scale(0.1) translate(calc(-100% + 4px), calc(-50% + 4px));
    transform-origin: top left;
  }

  to {
    transform: scale(1) translate(calc(-100% + 4px), calc(-50% + 4px));
    transform-origin: left;
  }
}
@keyframes hotspotPopupLeftOut {
  from {
    transform: scale(1) translate(calc(-100% + 4px), calc(-50% + 4px));
    transform-origin: left;
  }

  to {
    transform: scale(0.1) translate(calc(-100% + 4px), calc(-50% + 4px));
    transform-origin: top left;
  }
}
@keyframes hotspotPopupTopIn {
  from {
    transform: scale(0.1) translate(-50%, calc(-100% + 4px));
    transform-origin: top left;
  }

  to {
    transform: scale(1) translate(-50%, calc(-100% + 4px));
    transform-origin: left;
  }
}
@keyframes hotspotPopupTopOut {
  from {
    transform: scale(1) translate(-50%, calc(-100% + 4px));
    transform-origin: left;
  }

  to {
    transform: scale(0.1) translate(-50%, calc(-100% + 4px));
    transform-origin: top left;
  }
}
@keyframes hotspotPopupBottomIn {
  from {
    transform: scale(0.1) translate(-50%, 0);
    transform-origin: top left;
  }

  to {
    transform: scale(1) translate(-50%, 0);
    transform-origin: left;
  }
}
@keyframes hotspotPopupBottomOut {
  from {
    transform: scale(1) translate(-50%, 0);
    transform-origin: left;
  }

  to {
    transform: scale(0.1) translate(-50%, 0);
    transform-origin: top left;
  }
}
.callout-popup {
  display: flex;
  /* transform: translateY(-50%); */
}
.callout-popup.right {
  transform: translate(0, calc(-50% + 4px));
}
.callout-popup.left {
  transform: translate(calc(-100% + 4px), calc(-50% + 4px));
}
.callout-popup.top {
  transform: translate(-50%, calc(-100% + 4px));
}
.callout-popup.bottom {
  transform: translate(-50%, 0);
}
.callout-line {
  width: 50px;
}
.callout-content {
  padding: 8px;
  width: 100%;
  max-height: 400px;
  background: #ffffffa3;
  overflow: auto;
  border: 2px solid #fff;
  border-radius: 3px;
  position: relative;
}
.callout-content * {
  max-width: 100%;
}
.callout-content p {
  margin: 0px;
}
.cart-popover .tooltip-inner {
  background: #f9f9f9;
  color: black;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}
.cart-popover .tooltip-arrow {
  border-color: #f9f9f9;
}
.sprite-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.sprite-wrap > div {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
}
.rounded-dialog {
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/preview/Index.vue